<template>
  <main class="contenedor my-0 py-0">
    <LoadingSpinner v-if="loadingOptionsList || loading" />
    <div v-else>
      <div class="row">
        <!-- Header -->
        <div class="col-12 bg-white py-3 px-3 px-md-4 agency-header" v-if="model.user">
          <div
            v-if="model.client.subscriptionActive == '0' || model.client.subscriptionActive == null || model.client.subscriptionActive == ''">
            <div class="col-12 col-md-auto order-1 mr-md-2 mb-2 mb-md-0">
              <div class="d-flex align-items-center flex-wrap">
                <h6 v-if="model.client.client_status_name && model.client.client_status_id"
                  :class="'badge badge-' + getColor(model.client.client_status_id)"
                  class="badge-agency-header mr-2 col-md-auto order-1 mx-2">
                  <span
                    v-if="model.client.client_status_id == '1' || model.client.client_status_id == '2'">Onboarding</span>
                  <span v-else>{{ model.client.client_status_name }}</span>
                </h6>
                <h2 class="mb-0 font-weight-bold text-dark text-uppercase agency-header-title">{{ model.client.name }}
                </h2>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="col-12 col-md-auto order-1 mr-md-2 mb-2 mb-md-0">
              <div class="d-flex align-items-end flex-wrap">
                <h6 v-if="model.client.client_status_name && model.client.client_status_id"
                  :class="'badge badge-' + getColor(model.client.client_status_id)"
                  class="badge-agency-header mr-2 col-md-auto order-1 mx-2">
                  <span
                    v-if="model.client.client_status_id == '1' || model.client.client_status_id == '2'">Onboarding</span>
                  <span v-else>{{ model.client.client_status_name }}</span>
                </h6>
                <Tooltip :text="$t('lang.subscription.subscription_active')">
                  <img class="mr-2" width="42" height="37" src="@/assets/images/medal_subscription_active.png" alt="">
                </Tooltip>
                <h2 class="mb-0 font-weight-bold text-dark text-uppercase agency-header-title">{{ model.client.name }}
                </h2>
              </div>
            </div>
          </div>

          <div class="row align-items-start align-items-md-center no-gutters flex-wrap agency-header-row">
            <!-- Account Executive -->
            <div class="col-12 col-lg-2 order-2 mt-2 mx-3" v-if="oliverExecutiveLoaded">
              <label class="mb-0 small font-weight-bold">Account Executive</label>
              <IndustrySearch :option_list="userOliverExecutives" :default_values="UserOliverExecutive" :key="3"
                :multiple="false" :isDisabled="savingExceutiveUser" @selected="selectOliverExecutive" />
            </div>

            <!-- Account Manager -->
            <div class="col-12 col-lg-2 order-3 mt-2" v-if="oliverSalesLoaded">
              <label class="mb-0 small font-weight-bold">Account Manager</label>
              <IndustrySearch :option_list="userOliverSales" :default_values="userOliverSale" :key="3" :multiple="false"
                :isDisabled="savingOliverUser" @selected="selectOliverSale" />
            </div>

            <div
              class="col-12 col-md-auto order-5 order-md-5 mt-2 mt-md-0 ml-md-auto d-flex flex-wrap align-items-center justify-content-end justify-content-md-end">
              <!-- Client since -->
              <div class="d-flex align-items-center agency-header-calendar-wrap mr-md-4 mb-2 mb-md-0">
                <span
                  class="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center mr-2 agency-header-calendar-icon flex-shrink-0">
                  <i class="icon-calendar small"></i>
                </span>
                <div class="min-width-0 mr-4">
                  <div class="font-weight-bold">{{ formatLastStatusDate() }}</div>
                  <small class="text-muted">Last Status Date</small>
                </div>
                <span
                  class="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center mr-2 agency-header-calendar-icon flex-shrink-0">
                  <i class="icon-calendar small"></i>
                </span>
                <div class="min-width-0 mr-5">
                  <div class="font-weight-bold">{{ clientSignedOn() }}</div>
                  <small class="text-muted">Client since</small>
                  <button
                    v-if="hasPermissions('superAdmin')"
                    type="button"
                    class="align-self-end btn btn-sm btn-theme-bg-transparent ml-2"
                    @click="getContractClient"
                    :disabled="loadingContract"
                  >
                    <i class="icon-download ml-2"></i>
                  </button>
                  <span
                    v-if="hasPermissions('superAdmin') && loadingContract"
                    class="loadingres spinner-border loading-spinner ml-2 text-white"
                  ></span>
                </div>
              </div>
              <div class="d-flex flex-column align-items-stretch align-items-md-end">
                <a class="text-primary mb-2 text-nowrap"
                  href="https://www.notion.so/Checklist-to-launch-campaigns-3352a447fa604424b524e13ca90e0ea8"
                  target="_blank">Frecuently asked questions</a>
                <div class="d-flex flex-wrap justify-content-end">
                  <template v-if="model.client.id !== undefined && currentUser.role_id == 1 && model.client.hide != 1">
                    <button class="btn btn-primary btn-sm mr-2 mb-1" @click.once="setAsFake()">SET AS FAKE
                      ACCOUNT</button>
                  </template>
                  <button
                    v-else-if="model.client.id !== undefined && currentUser.role_id == 1 && model.client.hide == 1"
                    class="btn btn-secondary btn-sm mr-2 mb-1" disabled>Fake account</button>
                  <button class="btn btn-primary btn-sm mr-2 mb-1" :disabled="loadingTxt" @click="exportTxt">
                    <span v-if="!loadingTxt">Campaign data extract</span>
                    <span v-else>Processing...</span>
                  </button>
                  <router-link v-if="model.client.id !== undefined && model.client.client_status_id != 6"
                    :to="'/downgrade/' + model.client.id" class="btn btn-danger btn-sm mb-1">Delete</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 px-3 px-md-4" v-if="model.user && hasPermissions('superAdmin')">
          <div v-if="!loading && alert.message && !submittedSecond" :class="`login-alert alert ${alert.type}`"
            v-html="alert.message"></div>
        </div>
      </div>

      <!-- Main -->
      <div class="col-12">
        <div class="row">
          <!-- List Options (menu) -->
          <div class="col-2 px-0 mx-0">
            <Tabs v-if="tabs.length > 0" :tabs="tabs" :tab-selected="selectedOptionId" :DesignFromSalesRidge="true"
              @change="optionSelected" />
          </div>
          <!-- Content -->
          <div class="col-10 my-0 agency-form-frame">
            <!-- Summary -->
            <div v-if="isOptionSelected('summary')" class="table-responsive m-0 p-0">
              <LoadingSpinner v-if="loadingData" />
              <div class="col-md-12 col-md order-4 mt-2 mt-md-0 mr-md-2 agency-summary-stats-wrapper"
                v-if="hasPermissions('superAdmin') && !loadingData">
                <div class="d-flex align-items-flex-start flex-wrap justify-content-left mt-5">
                  <small class="agency-summary-refresh icon-refresh cursor-pointer mr-3 mt-1" @click="getStats()"
                    :title="$t('lang.general.refresh')"></small>
                  <!-- Activity -->
                  <div class="agency-summary-section">
                    <h4 class="text-primary font-weight-bold mb-3">Activity</h4>
                    <div class="agency-summary-metrics-row d-flex flex-wrap">
                      <div class="agency-summary-metric">
                        <Tooltip :text="'Unique prospects'" :width="'130px'">
                          <img class="agency-header-metric-icon" src="@/assets/images/icon_contacts.png" alt="" />
                        </Tooltip>
                        <span v-if="loadingStats && loadingData" class="agency-summary-metric-gap">
                          <Loadingcircle :paramloading="paramloading" />
                        </span>
                        <span class="agency-summary-metric-val mt-2" v-else-if="model.client.stats">{{
                          model.client.stats.total_contacts ? model.client.stats.total_contacts : "0" }}</span>
                        <span v-else class="agency-summary-metric-val">__</span>
                        <span class="agency-summary-metric-label">Unique prospects</span>
                      </div>
                      <div class="agency-summary-metric">
                        <Tooltip :text="'Sent emails'" :width="'130px'">
                          <img class="agency-header-metric-icon" src="@/assets/images/icon_sent-mail.png" alt="" />
                        </Tooltip>
                        <span v-if="loadingStats && loadingData" class="agency-summary-metric-gap">
                          <Loadingcircle :paramloading="paramloading" />
                        </span>
                        <span class="agency-summary-metric-val mt-2" v-else-if="model.client.stats">{{
                          model.client.stats.total_email_sent ? model.client.stats.total_email_sent : "0" }}</span>
                        <span v-else class="agency-summary-metric-val">__</span>
                        <span class="agency-summary-metric-label">Unique emails</span>
                      </div>
                      <div class="agency-summary-metric">
                        <Tooltip :text="'Meetings'" :width="'130px'">
                          <img class="agency-header-metric-icon" src="@/assets/images/icon_agenda.png" alt="" />
                        </Tooltip>
                        <span v-if="loadingStats && loadingData" class="agency-summary-metric-gap">
                          <Loadingcircle :paramloading="paramloading" />
                        </span>
                        <span class="agency-summary-metric-val mt-2" v-else-if="model.client.stats">{{
                          model.client.stats.total_meetings ? model.client.stats.total_meetings : "0" }}</span>
                        <span v-else class="agency-summary-metric-val mt-2">__</span>
                        <span class="agency-summary-metric-label">Meetings</span>
                      </div>
                      <div v-if="!isUserOperational" class="agency-summary-metric">
                        <Tooltip :text="'Spent'" :width="'130px'">
                          <img class="agency-header-metric-icon" src="@/assets/images/icon_coin.png" alt="" />
                        </Tooltip>
                        <span v-if="loadingStats && loadingData" class="agency-summary-metric-gap">
                          <Loadingcircle :paramloading="paramloading" />
                        </span>
                        <span class="agency-summary-metric-val mt-2" v-else-if="model.client.stats">{{
                          model.client.stats.amount ? parseFloat(model.client.stats.amount).toFixed(0) + ' €' : "0"
                          }}</span>
                        <span v-else class="agency-summary-metric-val mt-2">__</span>
                        <span class="agency-summary-metric-label">Leads generated</span>
                      </div>
                    </div>
                  </div>
                  <!-- Conversion rates -->
                  <div class="agency-summary-section ml-5">
                    <h4 class="text-primary font-weight-bold mb-3">Conversion rates</h4>
                    <div class="agency-summary-metrics-row d-flex flex-wrap">
                      <div class="agency-summary-metric">
                        <Tooltip :text="'Meetings / Unique prospects'" :width="'130px'">
                          <img class="agency-header-metric-icon" src="@/assets/images/icon_bar-chart.png" alt="" />
                        </Tooltip>
                        <span v-if="loadingStats && loadingData" class="agency-summary-metric-gap">
                          <Loadingcircle :paramloading="paramloading" />
                        </span>
                        <span class="agency-summary-metric-val mt-2" v-else-if="model.client.stats">{{
                          model.client.stats.conversion_rate ? parseFloat(model.client.stats.conversion_rate).toFixed(2)
                          : "0"
                          }}%</span>
                        <span v-else class="agency-summary-metric-val mt-2">__</span>
                        <span class="agency-summary-metric-label">Global conv. rate</span>
                      </div>
                    </div>
                  </div>
                  <!-- CPI (Client Performance Index) -->
                  <div class="agency-summary-section ml-4 mt-4" v-if="model.client.cpi">
                    <div class="d-flex align-items-center justify-content-between mb-3">
                      <h4 class="text-primary font-weight-bold mb-0">CPI</h4>
                      <span v-if="cpiCategoryBadge" class="badge px-2 py-1 ml-2 font-weight-normal"
                        :style="{ backgroundColor: cpiCategoryBadge.bgColor, color: cpiCategoryBadge.textColor }">{{
                        cpiCategoryBadge.label }}</span>
                    </div>
                    <div class="agency-summary-metrics-row d-flex flex-wrap">
                      <div class="agency-summary-metric">
                        <Tooltip :text="'Avg. monthly revenue'" :width="'130px'">
                          <img class="agency-header-metric-icon" src="@/assets/images/icon_coin.png" alt="" />
                        </Tooltip>
                        <span class="agency-summary-metric-val mt-2">{{ model.client.cpi.avg_monthly_revenue != null ?
                          parseFloat(model.client.cpi.avg_monthly_revenue).toFixed(0) + ' €' : "__" }}</span>
                        <span class="agency-summary-metric-label">Avg. monthly revenue (3m)</span>
                      </div>
                      <div class="agency-summary-metric">
                        <Tooltip :text="'Total revenue'" :width="'130px'">
                          <img class="agency-header-metric-icon" src="@/assets/images/icon_coin.png" alt="" />
                        </Tooltip>
                        <span class="agency-summary-metric-val mt-2">{{ model.client.cpi.total_revenue != null ?
                          parseFloat(model.client.cpi.total_revenue).toFixed(0) + ' €' : "__" }}</span>
                        <span class="agency-summary-metric-label">Total invoiced</span>
                      </div>
                      <div class="agency-summary-metric" v-if="model.client.cpi.subscription != null">
                        <Tooltip :text="'Subscription'" :width="'130px'">
                          <img class="agency-header-metric-icon" src="@/assets/images/icon_coin.png" alt="" />
                        </Tooltip>
                        <span class="agency-summary-metric-val mt-2">{{ model.client.cpi.subscription != null ?
                          parseFloat(model.client.cpi.subscription).toFixed(0) + ' €' : "__" }}</span>
                        <span class="agency-summary-metric-label">Subscriptions</span>
                      </div>
                      <div class="agency-summary-metric">
                        <Tooltip :text="'Avg. meeting price (3m)'" :width="'130px'">
                          <img class="agency-header-metric-icon" src="@/assets/images/icon_agenda.png" alt="" />
                        </Tooltip>
                        <span class="agency-summary-metric-val mt-2">{{ model.client.cpi.avg_meeting_price_3m != null ?
                          parseFloat(model.client.cpi.avg_meeting_price_3m).toFixed(0) + ' €' : "__" }}</span>
                        <span class="agency-summary-metric-label">Avg. meeting price (3m)</span>
                      </div>
                      <div class="agency-summary-metric">
                        <Tooltip :text="'Meetings/month (3m)'" :width="'130px'">
                          <img class="agency-header-metric-icon" src="@/assets/images/icon_agenda.png" alt="" />
                        </Tooltip>
                        <span class="agency-summary-metric-val mt-2">{{ model.client.cpi.meetings_month_3m != null ?
                          parseFloat(model.client.cpi.meetings_month_3m).toFixed(2) : "__" }}</span>
                        <span class="agency-summary-metric-label">Meetings/month (3m)</span>
                      </div>
                      <div class="agency-summary-metric">
                        <Tooltip :text="'Meetings / Unique prospects (3m)'" :width="'130px'">
                          <img class="agency-header-metric-icon" src="@/assets/images/icon_bar-chart.png" alt="" />
                        </Tooltip>
                        <span class="agency-summary-metric-val mt-2">{{ model.client.cpi.meetings_unique_prospects_3m !=
                          null
                          ? parseFloat(model.client.cpi.meetings_unique_prospects_3m).toFixed(2) + ' %' : "__" }}</span>
                        <span class="agency-summary-metric-label">Meetings/Prospects (3m)</span>
                      </div>

                      <Tooltip :text="'(Meetings_M-1 − Meetings_M-2) / max(1, Meetings_M-2)'" :width="'280px'">
                        <div class="agency-summary-metric">
                          <img class="agency-header-metric-icon" src="@/assets/images/icon_bar-chart.png" alt="" />
                          <span class="agency-summary-metric-val mt-2">{{ model.client.cpi.trend_meetings != null ?
                            (model.client.cpi.trend_meetings > 0 ? '+ ' : '') +
                            parseFloat(model.client.cpi.trend_meetings).toFixed(2) + ' %' : "__" }}</span>
                          <span class="agency-summary-metric-label">Trend meetings</span>
                        </div>
                      </Tooltip>

                      <div class="agency-summary-metric">
                        <Tooltip :text="'Longevity (months)'" :width="'130px'">
                          <img class="agency-header-metric-icon" src="@/assets/images/icon_agenda.png" alt="" />
                        </Tooltip>
                        <span class="agency-summary-metric-val mt-2">{{ model.client.cpi.longevity_client != null ?
                          model.client.cpi.longevity_client : "__" }}</span>
                        <span class="agency-summary-metric-label">Longevity (months)</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Dashboard -->
            <div v-if="isOptionSelected('dashboard')">
              <BillingClientSpace :fromClient="fromClient" :client_id="Number(selectedClientId)" :user_id="Number(model.user.id)" />
            </div>

            <!-- Client info -->
            <div class="mt-2" v-if="isOptionSelected('client_info')">
              <vue-form-generator v-if="!hasPermissions('isBdr')" ref="clientForm" :schema="schemaClient"
                :model="this.model" :options="formOptions"></vue-form-generator>

              <vue-form-generator v-if="hasPermissions('isBdr')" ref="clientBookerForm" :schema="schemaBookerClient"
                :model="this.model" :options="formOptions"></vue-form-generator>

              <div class="form-group px-3 col-6" v-if="hasPermissions('superAdmin')">
                <label class="font-weight-bold">{{ $t("lang.label.affiliated_to") }}</label>
                <IndustrySearch v-if="clientsAffiliation.length > 0" :disabled="loadingAffiliation"
                  :option_list="clientsAffiliation" :default_values="model.client.agency" :key="3"
                  @input="model.client.agency = $event" />
              </div>
              <div class="form-group px-3 col-6" v-if="hasPermissions('superAdmin') || hasPermissions('isBdr')">
                <label>{{ $t("lang.label.industry") }}</label>
                <select class="form-control" v-model="model.client.industry" :disabled="hasPermissions('isBdr')">
                  <option v-for="data in this.$store.state.optionsList.all.categories_google_all.data" :key="data.id"
                    :value="data.apollo_id">
                    {{ data.label }}
                  </option>
                </select>
                <!-- :isDisabled="isDisable" -->
              </div>

              <div class="form-group px-3 col-6" v-if="hasPermissions('superAdmin') || hasPermissions('isBdr')">
                <label>{{ $t("lang.label.clientKeywords") }}</label>
                <KeyWordSearch :taglimit="99" :multipleValuesAtOnce="true" ref="keywrods" :default_values="keywords"
                  @change="changeKeywords($event)" v-if="!loading" :anyOf="true" :notAnyOf="false"
                  :isDisabled="hasPermissions('isBdr')" />
              </div>
              <div class="form-group px-3 col-6" v-if="hasPermissions('superAdmin')">
                <label>{{ $t("lang.label.country") }}</label>
                <IndustrySearch class="mb-4" :option_list="hierarchyoptionsCountry" :default_values="country" :key="6">
                </IndustrySearch>
              </div>

              <div class="row" v-if="!hasPermissions('isBdr')">
                <div class="col-md-12 my-4">
                  <button class="btn btn-primary btn float-left" @click.once="setAgency()" :key="setAgencyKey">
                    {{ $t("lang.button.save") }}
                  </button>

                  <button class="btn btn-light btn float-left mr-2" @click="goBack()">
                    {{ $t("lang.button.cancel") }}
                  </button>
                </div>
              </div>
            </div>

            <div v-if="isOptionSelected('consignes_bookers')" class="table-responsive m-0 p-0">
              <ClientBookingSignal :client_id="Number(selectedClientId)" />
            </div>

            <!-- Offer -->
            <div v-if="isOptionSelected('offer_view')" class="table-responsive m-0 p-0">
              <vue-form-generator v-if="!hasPermissions('isBdr')" ref="offerForm" :schema="offerSchema"
                :model="this.model" :options="formOptions"></vue-form-generator>
              <div v-if="!hasPermissions('isBdr')" class="row px-3">
                <template v-if="isChurnContext">
                  <div class="form-group col-md-6 churn-category-field">
                    <label>
                      Catégorie de churn
                      <span v-if="churnCategoryIsRequired" class="text-danger">*</span>
                    </label>
                    <select
                      class="form-control"
                      v-model="model.client.churn_category"
                      :required="churnCategoryIsRequired"
                    >
                      <option disabled value="">Sélectionner une catégorie</option>
                      <optgroup
                        v-for="group in churnCategoryGroups"
                        :key="group.family"
                        :label="group.family"
                      >
                        <option
                          v-for="category in group.categories"
                          :key="category"
                          :value="category"
                        >
                          {{ category }}
                        </option>
                      </optgroup>
                    </select>
                  </div>
                  <div v-if="hasChurnCategory" class="form-group col-md-6">
                    <label>Détail du churn (optionnel)</label>
                    <textarea
                      class="form-control"
                      v-model="model.client.internal_details"
                      maxlength="500"
                      rows="3"
                    ></textarea>
                  </div>
                </template>
                <div v-else class="form-group col-md-6">
                  <label>Billing specifications</label>
                  <textarea
                    class="form-control"
                    v-model="model.client.internal_details"
                    maxlength="500"
                    rows="3"
                  ></textarea>
                </div>
              </div>
              <!-- Link proporsal to client -->
              <div class="col-md-12 text-center px-3 my-2" v-if="!hasPermissions('isBdr')">
                <h6>Proposal link:</h6>
                <template v-if="canShareProposal">
                  <a :href="getProporsalLink()" target="_blank" class="text-primary">
                    {{ getProporsalLink() }}
                  </a>
                  <i class="icon icon-clipboard cursor-pointer mr-2 ml-2"
                    :title="$t('lang.general.copytoclipboard') + ': Link'"
                    @click="copyCalendarLink(getProporsalLink())"></i>
                </template>
                <template v-else>
                  <p class="text-danger mb-0">
                    Kickoff date is required before sharing the proposal.
                  </p>
                </template>
              </div>
              <div class="row" v-if="!hasPermissions('isBdr')">
                <div class="col-md-12 my-4">
                  <button class="btn btn-primary btn float-right" @click.once="setAgency()" :key="setAgencyKey">
                    {{ $t("lang.button.save") }}
                  </button>

                  <button class="btn btn-light btn float-right mr-2" @click="goBack()">
                    {{ $t("lang.button.cancel") }}
                  </button>
                </div>
              </div>
            </div>

            <!-- Orders -->
            <div v-if="isOptionSelected('orders')">
              <Orders :fromClient="fromClient" :client_id="Number(selectedClientId)" />
            </div>

            <!-- Team -->
            <div v-if="isOptionSelected('team')">
              <TableMonitor v-if="activityopen" :key="activityKey" :team_id="selectedClientId" :showOtherUsers="true"
                @refresh="refresh()" @opencalendar="opencalendar($event)" @newUser="newUser()"
                @openTeam="openTeam($event)">
              </TableMonitor>

              <Modal :name="'team'" height="auto" width="80%">
                <ListSDRTeam v-if="sales_selected" :client_id="selectedClientId" :user_id="sales_selected">
                </ListSDRTeam>
              </Modal>
            </div>

            <!-- Users -->
            <div v-if="isOptionSelected('users')">
              <UserClientView :key="activityKey" :team_id="selectedClientId" @refresh="refresh()"
                @opencalendar="opencalendar($event)" @newUser="newUser()" @newemail="newemail()">
              </UserClientView>
            </div>

            <!-- Billing Dashboard -->
            <div class="mt-3" v-if="isOptionSelected('billing_dashboard')">
              <InvoiceViewer :userId="model.user.id" v-if="billingDashboardactive" />
            </div>

            <!-- Billing -->
            <div v-if="isOptionSelected('billing')">
              <BillingInfo :userId="model.user.id"
                :nextPaymentDate="(model.client.nextPaymentDate) ? model.client.nextPaymentDate : NULL"
                :subscriptionFree="model.client.subscriptionFree"
                :subscriptionDeferredBilling="model.client.subscriptionDeferredBilling"
                :billingTrigger="model.client.billingTrigger"
                :kickoffDate="model.client.kickoff_date"
                v-if="billing" />
            </div>

            <!-- Statistiques -->
            <div class="p-0 m-0" v-if="isOptionSelected('statistiques')">
              <DashboardAdmin v-if="dashboardactive" :clientId="selectedClientId"></DashboardAdmin>
            </div>

            <!-- Mailbox -->
            <div v-if="isOptionSelected('mailbox_history')">
              <AccountEmailList :clientId="selectedClientId" :fromClient="true"></AccountEmailList>
            </div>

            <!-- Excluded_domains -->
            <div v-if="isOptionSelected('excluded_domains')">
              <BlackList :clientId="Number(selectedClientId)" />
            </div>

            <!-- Activity -->
            <div v-if="isOptionSelected('activity')">
              <ListNotifications :clientId="Number(selectedClientId)" />
            </div>

            <!-- formation -->
            <div v-if="isOptionSelected('formation')">
              <LoadingSpinner v-if="formationLoading" />
              <div class="row" v-if="!formationLoading">
                <div class="col-12">
                  <div class="float-right" v-if="hasPermissions('superAdmin')">
                    <button class="btn btn-primary" @click="getFormation()">
                      Get Formation
                    </button>
                  </div>
                  <h2>Formation:</h2>
                </div>
                <div class="col-12">
                  <div class="card mt-2 mb-lg-2 p-3">
                    <div v-if="!editFormation">
                      <!-- <pre>{{ model.client.formation }}</pre> -->

                      <div v-if="model.client.formation"
                        v-html="parseMarkdown(preprocessMarkdown(model.client.formation))">
                      </div>
                      <!-- <p v-if="model.client.formation != '' && model.client.formation != null"
                      v-html="parseMarkdown(model.client.formation)"></p> -->
                      <p v-else>No formation available.</p>
                    </div>


                    <div v-if="editFormation">
                      <!-- <textArea v-model="model.client.formation" class=""></textArea> -->
                      <ckeditor :editor="editorInitial" v-model="model.client.formation" :config="editorConfig">
                      </ckeditor>
                      <!-- <ckeditor :editor="editorInitial" v-model="editFormationMod" :config="editorConfig"></ckeditor> -->
                    </div>

                  </div>
                  <div class="float-right" v-if="hasPermissions('superAdmin')">
                    <!-- <button class="btn btn-success" @click="setAgency()">Save</button>
                    <button class="btn btn-success ml-2" @click="editFormation = true">Edit</button> -->

                    <button class="btn btn-success" @click="saveFormation()">Save</button>
                    <button class="btn btn-success ml-2" @click="updateFormation()">Edit</button>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <h2>Bookers filter</h2>
                  <BdrTask :clientId="this.selectedClientId" :withTaskType="['coldphoning']" :withMeeting="[1]"
                    :withIputRange="false" />
                </div>
              </div>
            </div>

            <!-- formation -->
            <div v-if="isOptionSelected('coldCallTraining')">
              <div class="row" v-if="!hasPermissions('isBdr')">
                <div class="col-6">
                  <h2>Training agent link</h2>
                  <br>
                  <input type="text" class="form-control" v-model="model.client.elevenlab_agent_id" />

                </div>
                <button class="btn btn-success mt-2" @click.once="setAgency()" :key="setAgencyKey">{{
                  $t("lang.button.save")
                  }}</button>
              </div>
              <div v-if="hasPermissions('isBdr')">
                <div class="row p-3">
                  <div class="col-12">
                    <h2>Training</h2>

                    <br>
                    <BdrCallTraining :client="model.client" :booker_id="currentUser.id" />

                  </div>
                </div>
              </div>


            </div>

            <!-- @saved="$store.dispatch('alert/success', 'Agent AI — prompt enregistré.', { root: true })" -->
            <!-- Agent-AI -->
            <div v-if="isOptionSelected('agentAI')" class="p-2">
              <AgentAIClient
                v-if="selectedClientId"
                :client-id="selectedClientId"
                @error="(msg) => $store.dispatch('alert/error', msg, { root: true })"
                @clear-error="$store.dispatch('alert/clear', null, { root: true })"
              />
            </div>

            <!-- Atelier d'analyse -->
            <div v-if="isOptionSelected('analysisWorkshop')" class="p-2">
              <AtelierAnalyseClient
                v-if="selectedClientId"
                :client-id="selectedClientId"
              />
            </div>


          </div>
        </div>
      </div>
      <!-- </div> -->

      <!-- <div class="row" v-if="!loadingOptionsList && !loading"> -->
      <div class="row" v-if="false">
        <div class="col-md-12">
          <img src="@/assets/images/2.png" class="rounded mx-auto d-block" width="150px" />
          <h2 class="text-lg-center my-4">
            {{ $t("lang.appointments.commercialproposal") }}
          </h2>
          <h5 class="text-lg-center">{{ model.client.name }}</h5>

          <div v-if="!loading">
            <div v-if="alert.message && !submittedSecond" :class="`login-alert alert ${alert.type}`"
              v-html="alert.message">
            </div>
          </div>
          <div class="float-right" v-if="
            model.client.id !== undefined &&
            model.client.client_status_id != 6
          ">
            <router-link :to="'/downgrade/' + model.client.id" class="btn btn-danger">DELETE</router-link>
          </div>
          <div class="float-right" v-if="
            model.client.id !== undefined &&
            currentUser.role_id == 1 &&
            model.client.hide != 1
          ">
            <button @click.once="setAsFake()" class="btn btn-primary mr-3">
              SET AS FAKE ACCOUNT
            </button>
          </div>
          <div class="float-right" v-else-if="
            model.client.id !== undefined &&
            currentUser.role_id == 1 &&
            model.client.hide == 1
          ">
            <button class="btn btn-primary mr-3" disabled>FAKE ACCOUNT</button>
          </div>
          <div>
            <Fieldset title="Client Info" :mykey="1232" :open="false">
              <vue-form-generator ref="clientForm" :schema="schemaClient" :model="this.model"
                :options="formOptions"></vue-form-generator>
              <div class="form-group px-3 col-6" v-if="hasPermissions('superAdmin')">
                <label class="font-weight-bold">{{ $t("lang.label.affiliated_to") }}</label>
                <IndustrySearch :disabled="loadingAffiliation" :option_list="clientsAffiliation"
                  :default_values="model.client.agency" :key="3" @input="model.client.agency = $event" />
              </div>
            </Fieldset>
          </div>
          <div>
            <Fieldset @opennow="
              openTarget = true;
            removeClass();
            " :title="$t('lang.orders.orders')" :mykey="344" :open="false">
              <div class="table-responsive">
                <Orders :fromClient="fromClient" :client_id="Number(selectedClientId)" />
              </div>
            </Fieldset>
          </div>

          <Fieldset v-if="showAppointmentConfig" title="Appointment/Sales" :mykey="754" :open="false">
            <div class="row">
              <div class="col-md-12">
                <h4 class="mt-5">Appointment config</h4>
                <vue-form-generator ref="appointmentForm" :schema="schemaAppointment" :model="this.model"
                  :options="formOptions"></vue-form-generator>
              </div>
              <div class="col-md-12">
                <h4>
                  <h4 class="mt-5 form-group required">
                    <label>Sales Reps</label>
                  </h4>
                  <span class="badge badge-success cursor-pointer" @click="openSalesRep(true)">
                    <i class="icon-plus" v-if="!currentSalesRepWrapper"></i>
                  </span>
                </h4>
                <div class="row" v-if="currentSalesRepWrapper">
                  <div class="col-md-6" v-if="formOpen">
                    <div class="w-100">
                      <button class="text-danger btn btn-disabled btn float-right mr-2 small"
                        @click="openSalesRep(false)">
                        <i class="icon-close mr-2"></i>{{ $t("lang.button.close") }}
                      </button>
                    </div>
                    <vue-form-generator ref="salesRepForm" :schema="schemaSalesRep" :model="this.currentSalesRep"
                      :options="formOptions"></vue-form-generator>
                    <button class="btn btn-success btn w-100" @click="
                      addItem(
                        'model.salesRep',
                        'currentSalesRep',
                        'email',
                        'salesRepForm'
                      );

                    formOpen = false;
                    ">
                      <i class="icon-plus mr-2"></i>{{ $t("lang.label.donefilter") }}
                    </button>
                  </div>
                  <div :class="formOpen ? 'col-md-6' : 'col-md-12'" class="card shadow p-4" v-if="
                    this.model.salesRep != undefined &&
                    this.model.salesRep.length > 0
                  ">
                    <Table :headers="headersSalesRep" :cols="colsSalesRep" :data="model.salesRep" :checkbox="false"
                      :notselect="true" :myvalues="domain_config_values" :model="model" @editAnItem="editAnItem"
                      @removeAnItem="removeAnItem">
                    </Table>
                  </div>
                  <button v-if="!formOpen && false" @click="openForm" class="btn btn-success">
                    {{ $t("lang.search.add") }}
                  </button>
                </div>
              </div>
            </div>
          </Fieldset>
          <Fieldset v-if="false" title="Pitch/domain config" :mykey="56732" :open="false">
            <div class="row">
              <div class="col-md-12">
                <div class="field-ckeditor-wrappar" v-if="false">
                  <ValidationProvider ref="editorPitchV" :rules="{
                    required: true,
                    'length-plain-text': [{ max: 750 }],
                  }">
                    <div slot-scope="{ errors }">
                      <div class="form-group valid featured required field-input field-ckeditor" :class="errors !== undefined && errors.length > 0
                        ? 'error'
                        : ''
                        ">
                        <label> {{ $t("lang.appointments.pitch") }}</label>
                        <div class="small">
                          {{ $t("lang.appointments.pitch_info") }}
                        </div>
                        <ckeditor :editor="editorInitial" v-model="editorPitch" :config="editorConfig"></ckeditor>

                        <div class="errors help-block">
                          <span>{{ errors[0] }}</span>
                        </div>
                      </div>
                    </div>
                  </ValidationProvider>
                </div>
              </div>

              <div class="col-md-12">
                <div class="field-ckeditor-wrappar">
                  <ValidationProvider ref="editorExtraInfoV" :rules="{ 'length-plain-text': [{ max: 750 }] }">
                    <div slot-scope="{ errors }">
                      <div class="form-group valid featured field-input field-ckeditor" :class="errors !== undefined && errors.length > 0
                        ? 'error'
                        : ''
                        ">
                        <label> {{ $t("lang.appointments.extrainfo") }}</label>
                        <div class="small">.</div>
                        <ckeditor :editor="editorInitial" v-model="editorExtraInfo" :config="editorConfig"></ckeditor>

                        <div class="errors help-block">
                          <span>{{ errors[0] }}</span>
                        </div>
                      </div>
                    </div>
                  </ValidationProvider>
                </div>
              </div>
            </div>

            <AgencyExtraForm :model="model" v-if="
              hasPermissionsAdminClients() && selectedClientId !== undefined
            " />
          </Fieldset>

          <div class="row">
            <div class="col-md-12 my-4">
              <button class="btn btn-success btn float-right" @click.once="setAgency()" :key="setAgencyKey">
                {{ $t("lang.button.save") }}
              </button>

              <button class="btn btn-disabled btn float-right mr-2" @click="goBack()">
                {{ $t("lang.button.cancel") }}
              </button>
            </div>
          </div>
          <div v-if="
            hasPermissionsAdminClients() && selectedClientId !== undefined
          ">
            <Fieldset title="Team" :mykey="23232" :open="false" @opennow="activityopen = true">
              <TableMonitor v-if="activityopen" :key="activityKey" :team_id="selectedClientId" :showOtherUsers="true"
                @refresh="refresh()"></TableMonitor>
            </Fieldset>
          </div>
          <div v-if="
            hasPermissionsAdminClients() && selectedClientId !== undefined
          ">
            <Fieldset title="Billing Dashboard" :mykey="54532" :open="false" @opennow="billingDashboardactive = true">
              <InvoiceViewer :userId="model.user.id" v-if="billingDashboardactive" />
            </Fieldset>
          </div>

          <div v-if="
            hasPermissionsAdminClients() && selectedClientId !== undefined
          ">
            <Fieldset title="Billing" :mykey="493929112" :open="false" @opennow="billing = true">
              <div class="mt-4">
                <BillingInfo :userId="model.user.id"
                  :nextPaymentDate="(model.client.nextPaymentDate) ? model.client.nextPaymentDate : NULL"
                  :subscriptionFree="model.client.subscriptionFree"
                  :subscriptionDeferredBilling="model.client.subscriptionDeferredBilling"
                  :billingTrigger="model.client.billingTrigger"
                  :kickoffDate="model.client.kickoff_date"
                  v-if="billing" />
              </div>
            </Fieldset>

            <Fieldset title="Statistics" :mykey="34565675678" :open="false" @opennow="dashboardactive = true">
              <DashboardAdmin v-if="dashboardactive" :clientId="selectedClientId"></DashboardAdmin>
            </Fieldset>
            <Fieldset title="Excluded domains" :mykey="3432565675678" :open="false">
              <AgencyImportExcludeDomains :clientId="selectedClientId" />
            </Fieldset>
            <Fieldset title="Notifications" :mykey="3432565675611" :open="false">
              <div class="row">
                <div class="col-12">
                  <ListNotifications :clientId="Number(selectedClientId)" />
                </div>
              </div>
            </Fieldset>
          </div>
        </div>
      </div>

      <!-- Modal: Form data user   -->
      <Modal :name="'sales'" height="auto" width="80%">
        <div>
          <div class="p-4 text-center">
            <label>
              <h4>{{ $t("lang.user.add") }}</h4>
            </label>
          </div>
          <div class="px-4 pb-4 text-center">
            <!-- :clientStatus="clientStatus()" -->
            <AddTeamMember :client_id="selectedClientId" @newForm="addMemberSales($event)" :add="true" />
          </div>
        </div>
      </Modal>
    </div>
  </main>
</template>

<script>
import TargetModal from "@/components/Onboarding/TargetsModal.vue";
import Tabs from "@/components/Common/Tabs.vue";
import AlertError from "@/components/AlertError.vue";
import { mapState, mapActions, mapGetters } from "vuex";
import Fieldset from "@/components/Common/Fieldset.vue";

import ListSDRTeam from "@/components/SalesRepresentative/ListSDRTeam.vue";
import {
  clientsService,
  targetsService,
  campaignsService,
  myCalendarService,
  usersService,
  notificationService,
  openaiService,
} from "@/_services";
import VueFormGenerator from "vue-form-generator";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import IndustrySearch from "@/components/AccountCreation/Steps/Campaign/search/IndustrySearch.vue";
import EmployeeSearch from "@/components/AccountCreation/Steps/Campaign/search/EmployeeSearch.vue";
import PopupItem from "@/components/AccountCreation/Steps/Campaign/search/Popup-item.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import KeyWordSearch from "@/components/AccountCreation/Steps/Campaign/search/KeyWordSearch.vue";
import {
  parseContactSearchError,
} from "@/_helpers/salesridgeSearchError";
import AgencyExtraForm from "./AgencyExtraForm.vue";
import BillingInfo from "@/components/Users/BillingInfo.vue";
import { itemsMixin } from "@/_mixins/";
import TableMonitor from "@/components/Dashboard/Monitor/Table.vue";
import Table from "@/components/Common/Table.vue";
import UserClientView from "@/components/Users/UserClientView.vue";
import DashboardAdmin from "@/components/Dashboard/DashboardAdmin.vue";
import AgencyImportExcludeDomains from "@/components/Agencies/AgencyImportExcludeDomains.vue";
import BlackList from "@/components/Account/BlackList.vue";
import ListNotifications from "@/components/Account/ListNotifications.vue";
import moment from "moment";
import Loadingcircle from "@/components/Common/Loadingcircle.vue";
import TargetsView from "@/components/Agencies/TargetsView.vue";
import Orders from "../Onboarding/Orders.vue";
import InvoiceViewer from "@/components/Common/InvoiceViewer.vue";
import Tooltip from "@/components/Common/Tooltip.vue";
import AddTeamMember from "@/components/Onboarding/AddTeamMember.vue";
import BdrTask from "@/components/BDR/BdrTasks.vue";
import BdrCallTraining from "../BDR/BdrCallTraining.vue";
import AgentAIClient from "@/components/Agencies/AgentAIClient.vue";
import AtelierAnalyseClient from "@/components/Agencies/AtelierAnalyseClient.vue";
import AccountEmailList from "../Emails/AccountEmailList.vue";
import BillingClientSpace from "@/components/Billing/BillingClientSpace.vue";
import ClientBookingSignal from "@/components/Agencies/ClientBookingSignal.vue";
import { CHURN_CATEGORY_GROUPS } from "@/_helpers/churnCategories";
import { has } from "core-js/core/dict";

export default {
  props: {
    selectedClientId: String,
  },
  mixins: [itemsMixin],
  data() {
    var self = this;
    return {
      churnCategoryGroups: CHURN_CATEGORY_GROUPS,
      trainingLink: "",
      editFormation: false,
      originalSubscriptionId: "",
      // Pause switch value as loaded: the API only touches billing when the admin changes it.
      originalSubscriptionFree: "",
      originalChurnContext: false,
      formationLoading: false,
      taskTypeFilter: ["coldphoning"],
      loadingAffiliation: false,
      clientsAffiliation: [],
      editFormationMod: null,
      loadingTxt: false,
      withMeeting: [1],
      oliverSalesLoaded: false,
      oliverExecutiveLoaded: false,
      savingOliverUser: false,
      userOliverSale: ['0'],
      previewUserOliverSale: "0",
      userOliverSales: [{ id: "0", label: "Select option..." }],
      savingExceutiveUser: false,
      UserOliverExecutive: ['0'],
      previewUserOliverExecutive: "0",
      userOliverExecutives: [{ id: "0", label: "Select option..." }],
      sales_selected: false,
      loadingContract: false,
      loadingData: false,
      paramloading: {
        width: "18px",
        height: "18px",
        color: "#5054EB",
      },
      optionDefault: 1,
      tabs: [],
      fromClient: true,
      showAppointmentConfig: false,
      salesRepList: [],
      formOpen: false,
      activityKey: 222,
      simpleheader: [
        {
          label: this.$t("lang.column.creationdate"),
          class: "overflowhide",
        },
        {
          label: "BDR",
          class: "overflowhide",
        },
        {
          label: "Type",
          class: "overflowhide",
        },
        {
          label: "Tasks Done",
          class: "overflowhide",
        },
        {
          label: "Action",
          class: "overflowhide",
        },
        {
          label: "Opportunity ID",
          class: "overflowhide",
        },
        {
          label: "Opportunity",
          class: "overflowhide",
        },
        {
          label: "Date close",
          class: "overflowhide",
        },
        {
          label: "Client",
          class: "overflowhide",
        },
        {
          label: "Client Status",
          class: "overflowhide",
        },
        {
          label: "Opportunity Temperature",
          class: "overflowhide",
        },
        {
          label: "Task Output",
          class: "overflowhide",
        },
        {
          label: "Meeting Planned",
          class: "overflowhide",
        },
        {
          label: "Winner",
          class: "overflowhide",
        },
        {
          label: "Contact name",
          class: "overflowhide",
        },
        {
          label: "Contact phone",
          class: "overflowhide",
        },
        // {
        //   label: "Call",
        //   class: "overflowhide",
        // },
      ],
      simplecols: [
        [
          {
            value: "created",
            class: "text-primary",
          },
        ],
        [
          {
            value: "bdr_name",
            class: "text-primary",
          },
        ],
        [
          {
            value: "task_type",
            class: "text-primary",
          },
        ],
        [
          {
            value: "tasks_done",
            class: "text-primary",
          },
        ],
        [
          {
            type: "multiple",
            conditions: [
              {
                value_if: "record",
                value_audio: "record",
                type: "audio",
              },
              {
                value_if: "entity_type",
                value: "email_sent",
                class: "icon-envelope text-primary",
                type: "icon",
                type2: "emit",
                emit: "showEmail",
              },
              {
                value_if: "entity_type",
                value: "ringover_event",
                class: "icon-phone text-primary",
                type: "icon",
                type2: "emit",
                emit: "showCall",
              },
              {
                value_if: "call_counts",
                value: "call_counts",
                type: "bubble",
                type2: "emit",
                emit: "showCall",
              },

              {
                badges: [
                  {
                    badge_if: "last_state",
                    badge_value: "FAILED",
                    badge_class: "badge badge-danger text-white",
                    badge_label: "CALL : FAILED",
                  },
                  // {
                  //   badge_if: "last_state",
                  //   badge_value: "ANSWERED",
                  //   badge_class: "badge badge-success text-white",
                  //   badge_label: "ANSWERED",
                  // },
                  {
                    badge_if: "last_state",
                    badge_value: "CANCELLED",
                    badge_class: "badge badge-warning text-white",
                    badge_label: "CALL : CANCELLED",
                  },
                  {
                    badge_if: "last_state",
                    badge_value: "CALL_ID_FAILED",
                    badge_class: "badge badge-danger text-white",
                    badge_label: "CALL : FAILED",
                  },
                ],
              },
            ],
          },
        ],
        [
          {
            value: "link_id",
          },
        ],
        [
          {
            value_label: "business_name",
            value_emit: "link_id",
            class: "text-primary",
            type: "emit",
            emit: "goToOpportunity",
          },
        ],
        [
          {
            value: "date_task_done",
            class: "text-primary",
          },
        ],
        [
          {
            value_label: "client_name",
            value_emit: "client_id",
            class: "text-primary",
            type: "emit",
            emit: "goToAgency",
          },
        ],
        [
          {
            value: "client_status",
          },
        ],
        [
          {
            value: "link_status_temperature_id",
            type: "itemBadge",
            class: "badge badge-primary",
            colors: [
              {
                id: 1,
                label: "Urgent",
                bgColor: "#008000",
                textColor: "#FFFFFF",
              },
              {
                id: 2,
                label: "Positive",
                bgColor: "#008000",
                textColor: "#FFFFFF",
              },
              {
                id: 3,
                label: "Introduction",
                bgColor: "#0000FF",
                textColor: "#FFFFFF",
              },
              {
                id: 4,
                label: "Wrong Contact",
                bgColor: "#0000FF",
                textColor: "#FFFFFF",
              },
              {
                id: 5,
                label: "Negative",
                bgColor: "#0000FF",
                textColor: "#FFFFFF",
              },
              {
                id: 6,
                label: "Calendar Inspection",
                bgColor: "#00FFFF",
                textColor: "#000000",
              },
              {
                id: 7,
                label: "Reschedule",
                bgColor: "#FFFF00",
                textColor: "#000000",
              },
              {
                id: 8,
                label: "Cold",
                bgColor: "#000000",
                textColor: "#FFFFFF",
              },
              {
                id: 9,
                label: "Other Answer",
                bgColor: "#FF9966",
                textColor: "#000000",
              },
            ],
          },
        ],

        [
          {
            value: "task_output",
            type: "itemBadge",
            class: "badge badge-primary",
            colors: [
              {
                id: "Meeting Booked",
                label: "Meeting Booked",
                bgColor: "green",
                textColor: "#FFFFFF",
              },
              {
                id: "Call back",
                label: "Call back",
                bgColor: "yellow",
                textColor: "gray",
              },
              {
                id: "No answer",
                label: "No answer",
                bgColor: "gray",
                textColor: "white",
              },
              {
                id: "No phone",
                label: "No phone",
                bgColor: "orange",
                textColor: "white",
              },
              {
                id: "No interest",
                label: "No interest",
                bgColor: "red",
                textColor: "#FFFFFF",
              },
              {
                id: "empty",
                label: "Empty",
                bgColor: "#008000",
                textColor: "#FFFFFF",
              },
            ],
          },
        ],
        [
          {
            badges: [
              {
                badge_if: "meeting_planned",
                badge_value: "1",
                badge_class: "badge badge-success text-white",
                badge_icon: "icon-check-circle",
              },
            ],
          },
        ],
        [
          {
            value: "bdr_name_winner",
            class: "text-primary",
          },
        ],
        [
          {
            value: "buasiness_contact_name",
            class: "text-primary",
          },
        ],
        [
          {
            value: "contact_phone",
            class: "text-primary",
          },
        ],
        // [
        //   {
        //     value_audio: "record",
        //     type: "audio",
        //   },
        // ],

        // [
        //   {
        //     value_if: "entity_type",
        //     value: "email_sent",
        //     type: "icon",
        //     class: "icon-envelope text-primary",
        //     type2: "emit",
        //     emit: "showEmail",
        //   },
        // ],
      ],
      headersSalesRep: [
        {
          label: this.$t("lang.label.name"),
          percentage: "20%",
          class: "overflowhide",
        },
        {
          label: this.$t("lang.label.lastname"),
          percentage: "20%",
          class: "overflowhide",
        },
        {
          label: this.$t("lang.label.email"),
          percentage: "20%",
          class: "overflowhide",
        },
        {
          label: this.$t("lang.label.phone"),
          percentage: "20%",
          class: "overflowhide",
        },
        {
          label: this.$t("lang.search.linkedin"),
          percentage: "20%",
          class: "overflowhide",
        },
        {
          label: this.$t("lang.label.domain"),
          percentage: "20%",
          class: "overflowhide",
        },
        {
          label: "Calendly url",
          percentage: "20%",
          class: "overflowhide",
        },
        {
          label: "Landing Page",
          percentage: "20%",
          class: "overflowhide",
        },
        {
          label: "Calendly token",
          percentage: "20%",
          class: "overflowhide",
        },
        {
          label: "",
          percentage: "10%",
          class: "overflowhide",
        },
        {
          label: "",
          percentage: "10%",
          class: "overflowhide",
        },
      ],
      colsSalesRep: [
        [
          {
            value: "first_name",
          },
        ],
        [
          {
            value: "last_name",
          },
        ],
        [
          {
            value: "email",
          },
        ],
        [
          {
            value: "phone",
          },
        ],
        [
          {
            value: "linkedinurl",
          },
        ],
        [
          {
            value: "workspace_domain_id",
            getvalue: true,
          },
        ],
        [
          {
            value: "landing_link",
          },
        ],
        [
          {
            value: "calendar_link",
          },
        ],
        [
          {
            value: "calendly",
          },
        ],
        /*[{
            'label' : this.$t('lang.label.edit'),
            'value_emit' : 'index',
            'class' : 'text-primary',
            'type':'emit',
            'icon':'icon-edit',
            'emit': 'editAnItem'
          }],
          [{
            'label' : this.$t('lang.label.remove'),
            'value_emit' : 'index',
            'class' : 'text-danger',
            'type':'emit',
            'icon':'icon-trash',
            'emit': 'removeAnItem'
          }],*/
      ],
      openTarget: false,
      targetsKey: 32432320,
      keywords: {
        anyof: [],
        known: [],
        unknown: [],
        notanyof: [],
      },
      workspace_domain_id: false,
      domain_config_values: [],
      targetdata: false,
      activityopen: false,
      dashboardactive: false,
      billingDashboardactive: false,
      team: false,
      billing: false,
      loading: true,
      setAgencyKey: 0,
      currentSalesRepWrapper: true,
      keywordscant: 0,
      currentTarget: {
        name: "",
        appt_quantity: "",
        launch_date_campaign: "",
        data: {
          categories_industry: [],
          employees: {},
          categories_level: [],
          categories_function: [],
          categories_jobs: {},
          region: [],
          countries: [],
        },
      },
      currentTargetKey: 0,
      currentTargetInit: {
        name: "",
        appt_quantity: "",
        launch_date_campaign: "",
        data: {
          categories_industry: [],
          employees: {},
          categories_level: [],
          categories_function: [],
          categories_jobs: {},
          region: [],
          countries: [],
        },
      },
      targetsLength: 0,
      // schema de client info desde la vista booker - con sus restricciones correspondientes
      schemaBookerClient: {
        fields: [
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.website"),
            model: "client.website",
            featured: true,
            readonly: true,
            min: 3,
            max: 255,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.address"),
            model: "client.address",
            featured: true,
            readonly: true,
            min: 5,
            max: 100,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.postalcode"),
            model: "client.postal_code",
            featured: true,
            readonly: true,
            min: 5,
            max: 10000,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.linkedinURL"),
            model: "client.linkedin_url",
            featured: true,
            readonly: true,
            min: 5,
            max: 100,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "number",
            label: this.$t("lang.label.foundedYear"),
            model: "client.founded_year",
            readonly: true,
            featured: true,
            validator: [
              VueFormGenerator.validators.required,
              VueFormGenerator.validators.date,
            ],
            visible() {
              return self.hasPermissions("adminClients");
            },
            format: "YYYY-MM-DD",
            styleClasses: "col-md-6 display-inline",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.city"),
            model: "client.city",
            featured: true,
            readonly: true,
            min: 5,
            max: 100,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.estimatedNumEmployees"),
            model: "client.num_employes",
            featured: true,
            readonly: true,
            min: 5,
            max: 100,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.annualRevenue"),
            model: "client.annual_revenue",
            featured: true,
            readonly: true,
            min: 5,
            max: 100,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "textArea",
            inputType: "textArea",
            label: "Client Specifications",
            model: "client.client_specifications",
            featured: true,
            readonly: true,
            styleClasses: "col-md-6",
          },
        ],
      },
      schemaSalesRep: {
        fields: [
          {
            type: "input",
            inputType: "hidden",
            model: "id",
            readonly: true,
            featured: false,
            disabled: true,
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.name"),
            model: "first_name",
            featured: true,
            readonly: false,
            required: true,
            disabled: false,
            min: 3,
            max: 50,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.lastname"),
            model: "last_name",
            featured: true,
            readonly: false,
            required: true,
            disabled: false,
            min: 3,
            max: 50,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.email"),
            model: "email",
            featured: true,
            readonly: false,
            required: true,
            disabled: false,
            validator: [
              VueFormGenerator.validators.string.locale({
                fieldIsRequired: this.$t("lang.label.required"),
              }),
              "emailValidator",
            ],
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.phone"),
            model: "phone",
            featured: true,
            readonly: false,
            required: true,
            disabled: false,
            min: 5,
            max: 50,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-3",
          },
          {
            type: "select",
            inputType: "number",
            label: this.$t("lang.label.domain"),
            model: "workspace_domain_id",
            readonly: false,
            featured: true,
            visible() {
              return self.hasPermissions("adminClients");
            },
            validator: VueFormGenerator.validators.required,
            values: () => {
              return this.domain_config_values;
            },
            styleClasses: "col-md-3",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.search.linkedin"),
            model: "linkedinurl",
            featured: true,
            readonly: false,
            disabled: false,
            min: 5,
            max: 50,
            validator: VueFormGenerator.validators.url.locale({
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{20}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: "Calendly Url",
            model: "calendar_link",
            featured: true,
            readonly: false,
            disabled: false,
            min: 5,
            max: 50,
            validator: VueFormGenerator.validators.url.locale({
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{20}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: "Landing Page Url",
            model: "landing_link",
            featured: true,
            readonly: false,
            disabled: false,
            min: 5,
            max: 50,
            validator: VueFormGenerator.validators.url.locale({
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{20}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: "Calendly Token",
            model: "calendly",
            featured: true,
            readonly: false,
            disabled: false,
            min: 3,
            max: 50,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
        ],
      },
      schemaTarget: {
        fields: [
          {
            type: "input",
            inputType: "text",
            model: "name",
            required: true,
            min: 5,
            max: 30,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
          },
          {
            type: "select",
            label: this.$t("lang.label.status"),
            model: "target_status_id",
            featured: true,
            required: true,
            values: function () {
              return [
                { id: "1", name: this.$t("lang.targets.active") },
                { id: "2", name: this.$t("lang.targets.stopped") },
              ];
            },
            default: "1",
          },
          {
            type: "input",
            inputType: "number",
            label: this.$t("lang.appointments.quantity"),
            model: "appt_quantity",
            readonly: false,
            disabled: false,
            min: 5,
            max: 10000,
            validator: ["numberBetweenValidator"],
            styleClasses: "",
          },
          {
            type: "input",
            inputType: "date",
            label: this.$t("lang.onBoarding.launch_date_campaign"),
            model: "launch_date_campaign",
            readonly: false,
            validator: [
              VueFormGenerator.validators.required,
              VueFormGenerator.validators.date,
            ],
            format: "YYYY-MM-DD",
          },
        ],
      },
      schemaEmployees: {
        fields: [
          {
            type: "input",
            inputType: "number",
            label: this.$t("lang.label.morethan"),
            model: "data.employees.keywords.greater",
            min: 0,
            max: 100000,
            required: false,
            validator: ["numberBetweenValidator"],
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "number",
            label: this.$t("lang.label.lessthan"),
            model: "data.employees.keywords.less",
            min: 0,
            max: 100000,
            required: false,
            validator: ["numberBetweenValidator"],
            styleClasses: "col-md-6",
          },
        ],
      },
      schemaAppointment: {
        fields: [
          {
            type: "input",
            inputType: "number",
            label: this.$t("lang.appointments.quantity"),
            model: "client.appt_quantity",
            featured: true,
            readonly: false,
            required: true,
            disabled: false,
            min: 5,
            max: 10000,
            validator: ["numberBetweenValidator"],
            styleClasses: "col-md-6 display-inline",
          },
          {
            type: "select",
            label: this.$t("lang.appointments.duration"),
            model: "client.appt_duration",
            readonly: false,
            featured: true,
            required: true,
            validator: VueFormGenerator.validators.required,
            values: [
              { id: 15, name: "15 " + this.$t("lang.label.minutes") },
              { id: 30, name: "30 " + this.$t("lang.label.minutes") },
              { id: 45, name: "45 " + this.$t("lang.label.minutes") },
              { id: 60, name: "60 " + this.$t("lang.label.minutes") },
            ],
            styleClasses: "col-md-6 display-inline",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.appointments.outreachdomain"),
            model: "client.outreach_domain",
            featured: true,
            readonly: false,
            required: true,
            disabled: false,
            min: 3,
            max: 255,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            hint: "&lt;your-domain&gt;-pro.com",
            styleClasses: "col-md-6 display-inline",
          },
          {
            type: "input",
            inputType: "date",
            label: this.$t("lang.appointments.startdate"),
            model: "client.appt_start_date",
            readonly: false,
            featured: true,
            required: true,
            validator: [
              VueFormGenerator.validators.required,
              VueFormGenerator.validators.date,
            ],
            // set: function(model, val) {
            //   model.client.appt_start_date = new Date(val).valueOf();
            // },
            format: "YYYY-MM-DD",
            // dateTimePickerOptions: {
            //   format: "YYYY-MM-DD HH:ii:ss",
            // },
            styleClasses: "col-md-6 display-inline",
          },
          {
            type: "select",
            label: this.$t("lang.appointments.synccrm"),
            model: "client.sync_crm",
            featured: true,
            readonly: false,
            required: true,
            disabled: false,
            values: [
              { id: 1, name: this.$t("lang.button.yes") },
              { id: 0, name: this.$t("lang.label.no") },
            ],
            styleClasses: "col-md-6 display-inline",
          },
          {
            type: "input",
            inputType: "number",
            label: this.$t("lang.appointments.meetingprice") + " (€ H.T)",
            model: "client.meeting_price",
            featured: true,
            readonly: false,
            required: true,
            visible: false,
            disabled() {
              return !self.hasPermissions("adminClients");
            },
            min: 1,
            max: 10000,
            validator: ["numberBetweenValidator"],
            styleClasses: "col-md-6 display-inline",
          },
        ],
      },
      editorInitial: ClassicEditor,
      editorPitch: "",
      country: [],
      editorExtraInfo: "",
      editorConfig: {
        toolbar: ["heading", "|", "bold", "italic", "|", "link"],
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
      },
      model_empty: { client: { ai_meeting_analisis: "0" }, user: {} },
      model: {},
      model_init: {},
      currentSalesRep: {},
      usersAm: [],
    };
  },
  components: {
    TargetModal,
    ListSDRTeam,
    AlertError,
    ckeditor: CKEditor.component,
    IndustrySearch,
    EmployeeSearch,
    Table,
    PopupItem,
    LoadingSpinner,
    KeyWordSearch,
    AgencyExtraForm,
    BillingInfo,
    Fieldset,
    TableMonitor,
    UserClientView,
    DashboardAdmin,
    AgencyImportExcludeDomains,
    TargetsView,
    Orders,
    InvoiceViewer,
    ListNotifications,
    Tabs,
    Loadingcircle,
    Tooltip,
    AddTeamMember,
    BdrTask,
    BlackList,
    BdrCallTraining,
    AgentAIClient,
    AtelierAnalyseClient,
    AccountEmailList,
    BillingClientSpace,
    ClientBookingSignal,
  },
  computed: {
    cpiCategoryBadge() {
      const categories = [
        { id: 'Strategic', label: 'Strategic', bgColor: '#28a745', textColor: '#FFFFFF' },
        { id: 'Core', label: 'Core', bgColor: '#007bff', textColor: '#FFFFFF' },
        { id: 'Watch', label: 'Watch', bgColor: '#fd7e14', textColor: '#FFFFFF' },
        { id: 'Low Priority', label: 'Low Priority', bgColor: '#6c757d', textColor: '#FFFFFF' },
        { id: 'Launching', label: 'Launching', bgColor: '#6f42c1', textColor: '#FFFFFF' },
        { id: '-', label: '-', bgColor: '#e9ecef', textColor: '#6c757d' }
      ];

      if (this.model.client.cpi.cpi_category && this.model.client.cpi.cpi_score) {
        const categoryId = this.model.client.cpi.cpi_category;
        if (categoryId == null || categoryId === '') return null;

        const category = categories.find(c => c.id === categoryId)
        category.label = category.label + ' ' + parseFloat(this.model.client.cpi.cpi_score).toFixed(2)
        if (category) {
          return category
        } else {
          return { id: categoryId, label: categoryId, bgColor: '#e9ecef', textColor: '#6c757d' };
        }

      } else {
        return ''
      }

    },
    offerSchema() {
      const self = this;
      const yesNoOptions = [
        { id: "1", name: this.$t("lang.button.yes") },
        { id: "0", name: this.$t("lang.label.no") },
      ];
      const client = this.model && this.model.client;
      const kickoffDateRequired = !this.isAccountManager;
      const plan = (client && client.subscriptionPlan) || "";
      const isDeferred = client && client.subscriptionDeferredBilling == 1;
      const subscriptionLabel = plan === ""
        ? this.$t("lang.label.monthlysubscription")
        : this.$t("lang.label.monthlysubscription") + " (Plan: " + (isDeferred ? plan + '/' + this.$t("lang.label.deferred") : plan) + ")";

      return {
        fields: [
          {
            type: "switch",
            label: this.$t("lang.label.subscription"),
            model: "client.subscriptionActive",
            featured: true,
            textOn: "Sub On",
            textOff: "Sub Off",
            valueOn: "1",
            valueOff: "0",
            styleClasses: "col-md-6",
          },
          {
            type: "select",
            disabled() {
              var c = self.model && self.model.client;
              return !c || !c.subscriptionActive || c.subscriptionActive === "0";
            },
            model: "client.subscriptionFree",
            featured: false,
            label: this.$t("lang.label.pause_subscription"),
            values: yesNoOptions,
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "number",
            label: "Price / meeting",
            model: "client.proposal_meeting_price",
            min: 0,
            default: 0,
            step: 0.01,
            validator(value) {
              if (value === null || value === undefined || value === "") {
                return [];
              }
              const parsed = Number(value);
              if (Number.isNaN(parsed) || parsed < 0) {
                return [self.$t("lang.label.missingdata")];
              }
              return [];
            },
            styleClasses: "col-md-6",
          },
          {
            type: "select",
            disabled() {
              var c = self.model && self.model.client;
              return (c && c.subscriptionActive === "1") ||
                (c && c.subscriptionIsFirstMonthFreeUsed == 1);
            },
            model: "client.subscriptionIsFirstMonthFree",
            featured: false,
            label: this.$t("lang.label.firstmonthfreeoffer"),
            values: yesNoOptions,
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "number",
            label: this.$t("lang.label.dedicated_bookers"),
            model: "client.dedicated_bookers",
            min: 0,
            max: 40,
            default: 0,
            validator(value) {
              if (value === null || value === undefined || value === "") {
                return [];
              }
              const parsed = Number(value);
              if (Number.isNaN(parsed) || parsed < 0 || parsed > 40) {
                return [self.$t("lang.label.missingdata")];
              }
              return [];
            },
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "number",
            disabled() {
              var c = self.model && self.model.client;
              return c && c.subscriptionActive === "1";
            },
            label: this.$t("lang.column.subscription_price_per_month"),
            model: "client.subscription_price_per_month",
            step: 0.01,
            featured: true,
            required: false,
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "number",
            disabled() {
              var c = self.model && self.model.client;
              return c && c.subscriptionActive === "1";
            },
            label: this.$t("lang.column.bookers_price_per_month"),
            model: "client.bookers_price_per_month",
            step: 0.01,
            featured: true,
            required: false,
            styleClasses: "col-md-6",
          },
          {
            // "dateNative" instead of inputType: "date": vue-form-generator's date
            // input routes every change through a debounced formatter that is null
            // on a reused instance, so the value never reached the model and the
            // kickoff guard blocked the save forever.
            type: "dateNative",
            disabled() {
              var c = self.model && self.model.client;
              return c && Number(c.kickoffDateLocked) === 1;
            },
            label: "Kickoff Date",
            model: "client.kickoff_date",
            readonly: false,
            featured: true,
            required: kickoffDateRequired,
            validator: kickoffDateRequired
              ? VueFormGenerator.validators.required.locale({
                  fieldIsRequired: this.$t("lang.label.required"),
                })
              : [],
            hint: "Billing starts one calendar month after kickoff (ConnectPulse).",
            styleClasses: "col-md-6 display-inline kickoff-date-field",
          },
          {
            type: "select",
            disabled() {
              var c = self.model && self.model.client;
              return (c && c.subscriptionActive === "1");
            },
            model: "client.contacts_active",
            featured: false,
            label: this.$t("lang.column.contacts_active"),
            values: yesNoOptions,
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "number",
            label: this.$t("lang.column.contacts_price_per_month"),
            disabled() {
              var c = self.model && self.model.client;
              return (c && c.subscriptionActive === "1") ||
                (c && c.contacts_active == 0);
            },
            model: "client.contacts_price_per_month",
            step: 0.01,
            featured: true,
            required: false,
            styleClasses: "col-md-6",
          },
          {
            type: "select",
            disabled() {
              var c = self.model && self.model.client;
              return (c && c.subscriptionActive === "1");
            },
            model: "client.bank_transfer_enabled",
            featured: false,
            label: this.$t("lang.column.bank_transfer_enabled"),
            values: yesNoOptions,
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "number",
            label: this.$t("lang.column.bank_transfer_contractual_days"),
            disabled() {
              var c = self.model && self.model.client;
              return (c && c.subscriptionActive === "1") ||
                (c && c.bank_transfer_enabled == 0);
            },
            model: "client.bank_transfer_contractual_days",
            featured: true,
            required: false,
            min: 0,
            max: 120,
            styleClasses: "col-md-6",
          },

          {
            type: "input",
            inputType: "number",
            label: this.$t("lang.column.enrich_email_price"),
            model: "client.enrich_email_price",
            step: 0.01,
            min: 0,
            featured: true,
            required: false,
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "number",
            label: this.$t("lang.column.enrich_phone_price"),
            model: "client.enrich_phone_price",
            step: 0.01,
            min: 0,
            featured: true,
            required: false,
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "number",
            label: "Closing moyen (%)",
            model: "client.signed_client_meeting_rate",
            step: 0.01,
            min: 0,
            featured: true,
            required: false,
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "number",
            label: "Panier moyen (LTV)",
            model: "client.avg_deal_value",
            step: 0.01,
            min: 0,
            featured: true,
            required: false,
            styleClasses: "col-md-6",
          },
          {
            type: "select",
            model: "client.ai_meeting_analisis",
            featured: false,
            label: this.$t("lang.column.ai_meeting_analisis"),
            values: yesNoOptions,
            styleClasses: "col-md-6",
          },
        ],
      };
    },
    schemaClient() {
      const self = this;
      const yesNoOptions = [
        { id: "1", name: this.$t("lang.button.yes") },
        { id: "0", name: this.$t("lang.label.no") },
      ];
      return {
        fields: [
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.firstname"),
            model: "user.name",
            featured: true,
            readonly: false,
            required: true,
            disabled: false,
            min: 3,
            max: 100,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.lastname"),
            model: "user.lastname",
            featured: true,
            readonly: false,
            required: true,
            disabled: false,
            min: 3,
            max: 100,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "select",
            label: this.$t("lang.label.language"),
            model: "user.language_id",
            readonly: false,
            featured: true,
            required: true,
            validator: VueFormGenerator.validators.required,
            selectOptions: {},
            values: () => {
              return self.langs.data;
            },
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.company"),
            model: "client.name",
            featured: true,
            readonly: false,
            required: true,
            disabled: false,
            min: 3,
            max: 100,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.email"),
            model: "user.email",
            featured: true,
            readonly: false,
            required: true,
            disabled() {
              return !self.hasPermissions("adminClients");
            },
            validator: [
              VueFormGenerator.validators.string.locale({
                fieldIsRequired: this.$t("lang.label.required"),
              }),
              "emailValidator",
            ],
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.phone"),
            model: "user.phone",
            featured: true,
            readonly: false,
            required: true,
            disabled: false,
            min: 5,
            max: 50,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.website"),
            model: "client.website",
            featured: true,
            readonly: false,
            required: true,
            disabled: false,
            min: 3,
            max: 255,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },

          {
            type: "input",
            inputType: "text",
            label: "SIREN",
            model: "client.vat_number",
            featured: true,
            readonly: true,
            required: false,
            disabled: false,
            min: 5,
            max: 100,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },

          {
            type: "input",
            inputType: "password",
            label: this.$t("lang.label.password"),
            model: "user.password",
            featured: true,
            required() {
              return self.selectedClientId === undefined;
            },
            validator(value, field, model) {
              if (
                self.selectedClientId === undefined ||
                (self.selectedClientId !== undefined &&
                  value != undefined &&
                  value != "")
              ) {
                return VueFormGenerator.validators.validatePassword(
                  value,
                  field,
                  model
                );
              }
              return [];
            },
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: "SIRET",
            model: "client.siret",
            featured: true,
            readonly: false,
            disabled: false,
            validator: VueFormGenerator.validators.siretValidator,
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.address"),
            model: "client.address",
            featured: true,
            readonly: false,
            disabled: false,
            min: 5,
            max: 100,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "date",
            label: this.$t("lang.appointments.signatureexpirationdate"),
            model: "client.signature_expiration_date",
            readonly: false,
            featured: true,
            validator: [
              VueFormGenerator.validators.required,
              VueFormGenerator.validators.date,
            ],
            visible() {
              return self.hasPermissions("adminClients");
            },
            format: "YYYY-MM-DD",
            styleClasses: "col-md-6 display-inline",
          },
          {
            type: "input",
            inputType: "number",
            label: this.$t("lang.label.foundedYear"),
            model: "client.founded_year",
            readonly: false,
            featured: true,
            validator: [
              VueFormGenerator.validators.required,
              VueFormGenerator.validators.date,
            ],
            visible() {
              return self.hasPermissions("adminClients");
            },
            format: "YYYY-MM-DD",
            styleClasses: "col-md-6 display-inline",
          },

          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.primaryPhone"),
            model: "client.primary_phone",
            featured: true,
            readonly: false,
            disabled: false,
            min: 5,
            max: 100,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },

          {
            type: "textArea",
            inputType: "textArea",
            label: this.$t("lang.label.seoDescription"),
            model: "client.seo_description",
            featured: true,
            readonly: false,
            disabled: false,
            min: 5,
            max: 100,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "textArea",
            inputType: "text",
            label: this.$t("lang.label.shortDescription"),
            model: "client.short_description",
            featured: true,
            readonly: false,
            disabled: false,
            min: 5,
            max: 10000,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.postalcode"),
            model: "client.postal_code",
            featured: true,
            readonly: false,
            disabled: false,
            min: 5,
            max: 10000,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.estimatedNumEmployees"),
            model: "client.num_employes",
            featured: true,
            readonly: false,
            disabled: false,
            min: 5,
            max: 100,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.city"),
            model: "client.city",
            featured: true,
            readonly: false,
            disabled: false,
            min: 5,
            max: 100,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.state"),
            model: "client.state",
            featured: true,
            readonly: false,
            disabled: false,
            min: 5,
            max: 100,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.linkedinURL"),
            model: "client.linkedin_url",
            featured: true,
            readonly: false,
            disabled: false,
            min: 5,
            max: 100,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.annualRevenue"),
            model: "client.annual_revenue",
            featured: true,
            readonly: false,
            disabled: false,
            min: 5,
            max: 100,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.salesDepartmentalHeadCount"),
            model: "client.departmental_head_count",
            featured: true,
            readonly: false,
            disabled: false,
            min: 5,
            max: 100,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "number",
            label: this.$t("lang.label.businessDevelopmentHeadCount"),
            model: "client.development_head_count",
            featured: true,
            readonly: false,

            disabled: false,
            min: 5,
            max: 100,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "textArea",
            inputType: "textArea",
            label: "Client Specifications",
            model: "client.client_specifications",
            featured: true,
            readonly: false,
            disabled: false,
            styleClasses: "col-md-6",
          },
          {
            type: "select",
            model: "client.client_cold_call",
            featured: false,
            label: "Cold Call",
            values: yesNoOptions,
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: "Playbook Url",
            model: "client.playbook_url",
            featured: true,
            readonly: false,
            disabled: false,
            min: 5,
            max: 100,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "datetime",
            label: this.$t("lang.appointments.signedon"),
            model: "client.signed_on",
            readonly: false,
            featured: true,
            required: false,
            validator: [VueFormGenerator.validators.date],
            visible() {
              return (
                self.hasPermissions("adminClients") &&
                ((self.model_init.client &&
                  self.model_init.client.signed_on === undefined) ||
                  (self.model_init.client &&
                    self.model_init.client.signed_on === null))
              );
            },
            format: "YYYY-mm-dd H:i:s",
            hint: this.$t("lang.appointments.signedonhint"),
            styleClasses: "col-md-6 display-inline",
          },
          // {
          //   type: "select",
          //   label: this.$t("lang.label.accountmanager"),
          //   model: "client.accountManager",
          //   readonly: false,
          //   featured: true,
          //   visible() {
          //     return self.hasPermissions("adminAgency");
          //   },
          //   validator: VueFormGenerator.validators.required,
          //   values: () => {
          //     return this.model.usersAm;
          //   },
          //   styleClasses: "col-md-6",
          // },
        ],
      };
    },
    ...mapState({
      loadingStats: (state) => state.campaigns.loadingStats,
      stats: (state) => state.campaigns.stats.data,
      currentUser: (state) => state.authentication.user,
      loadingOptionsList: (state) => !state.optionsList.completeLoadingAgency,
      langs: (state) => state.optionsList.all["languages"],
      hierarchyoptions: (state) => state.optionsList.all["regions"].data,
      hierarchyoptionsSearch: (state) =>
        state.optionsList.all["categories_search_words"].data,
      hierarchyoptionsSearchFunction: (state) =>
        state.optionsList.all["categories_search_function"].data,
      hierarchyoptionsSearchLevel: (state) =>
        state.optionsList.all["categories_search_level"].data,
      hierarchyoptionsGoogle: (state) =>
        state.optionsList.all["categories_google"].data,
      companySizeOptions: (state) => state.optionsList.all["param_5"].data,
      hierarchyoptionsGoogleAll: (state) =>
        state.optionsList.all["categories_google_all"].data,
      hierarchyoptionsCountry: (state) =>
        state.optionsList.all["countries"].data,
    }),
    loggingIn() {
      return this.$store.state.authentication.status.loggingIn;
    },
    isUserOperational() {
      return (
        this.currentUser.role_id == 1 &&
        this.currentUser.user_constraint_id == 1
      );
    },
    alert() {
      return this.$store.state.alert;
    },
    isUserOliverSale() {
      return (
        this.currentUser.role_id == 1 &&
        this.currentUser.user_constraint_id == 2
      );
    },
    // Account Managers must always be able to save the client sheet to
    // pause/resume the subscription: unrelated fields (kickoff date,
    // dedicated bookers) must never block that action.
    isAccountManager() {
      return (
        this.currentUser.role_id == 1 &&
        this.currentUser.user_constraint_id == 2
      );
    },
    canShareProposal() {
      const client = this.model && this.model.client;
      return !!(client && client.kickoff_date);
    },
    isChurnContext() {
      const client = this.model && this.model.client;
      if (!client) return false;

      const churnStatuses = [5, 6, 7, 8];
      return (
        (
          Number(client.client_status_id) === 4
          && (
            String(client.subscriptionActive) === "0"
            || Number(client.subscriptionFree) === 1
          )
        )
        || churnStatuses.includes(Number(client.client_status_id))
      );
    },
    churnCategoryIsRequired() {
      // Decisión de Thibault (04/09/2026): la categoría de churn la completa la IA
      // (rutina churn-oliverlist), no la persona. Dejarla obligatoria sólo agregaba
      // fricción al guardar y bloqueaba a quien no conoce el motivo del churn.
      // El campo se sigue mostrando y guardando igual: sólo deja de frenar el submit.
      return false;
    },
    hasChurnCategory() {
      const category = this.model
        && this.model.client
        && this.model.client.churn_category;
      return typeof category === "string" && category.trim() !== "";
    },
    selectedOptionId() {
      const selected = this.tabs.find((el) => el.selected === true);
      return selected ? selected.id : this.optionDefault;
    },
    isOptionSelected() {
      return (value) => {
        const idOptionSelected = this.tabs.find(
          (el) => el.selected == true && el.name === value
        );
        if (idOptionSelected) {
          return idOptionSelected.name === value ? true : false;
        } else {
          return false;
        }
      };
    },
  },

  created() {
    document.title = this.$t("lang.search.loading") + "...";
    //this.getDataStats();
    if (this.currentUser.role_id != 2) {
      this.getStats();
    }
    this.getAgency();
    this.getClientAffiliation();
    this.getAllOptionsList();

    this.$emit("loadingFinish");
    this.getUserOliverSales();
    this.getUserOliverExecutives();
  },

  mounted() {
    if (this.hasPermissions('adminAgency')) {
      this.tabs = [
        {
          id: 17,
          name: "dashboard",
          label: this.$t("lang.menu.dashboard"),
          selected: true,
          hasPermission: true,
        },
        {
          id: 14,
          name: "summary",
          label: this.$t("lang.menu.summary"),
          selected: false,
          hasPermission: true,
        },
        {
          id: 1,
          name: "client_info",
          label: this.$t("lang.menu.client_info"),
          selected: false,
          hasPermission: true,
        },
        {
          id: 18,
          name: "consignes_bookers",
          label: this.$t("lang.client_booking_signal.tab"),
          selected: false,
          hasPermission: true,
        },
        {
          id: 2,
          name: "offer_view",
          label: this.$t("lang.column.offer"),
          selected: false,
          hasPermission: true,
        },
        {
          id: 3,
          name: "orders",
          label: this.$t("lang.column.orders"),
          selected: false,
          hasPermission: true,
        },
        {
          id: 4,
          name: "team",
          label: this.$t("lang.label.team"),
          selected: false,
          hasPermission: true,
        },
        {
          id: 9,
          name: "mailbox_history",
          label: "Mailboxes",
          selected: false,
          hasPermission: true,
        },
        {
          id: 5,
          name: "users",
          label: "Users",
          selected: false,
          hasPermission: true,
        },
        {
          id: 6,
          name: "billing_dashboard",
          label: this.$t("lang.statistics.generated"),
          selected: false,
          hasPermission: !this.isUserOperational,
        },
        {
          id: 7,
          name: "billing",
          label: this.$t("lang.label.billing"),
          selected: false,
          hasPermission: !this.isUserOperational,
        },
        {
          id: 8,
          name: "statistiques",
          label: this.$t("lang.menu.statistics"),
          selected: false,
          hasPermission: true,
        },
        {
          id: 10,
          name: "excluded_domains",
          label: this.$t("lang.menu.excluded_domains"),
          selected: false,
          hasPermission: true,
        },
        {
          id: 11,
          name: "activity",
          label: this.$t("lang.menu.activity"),
          selected: false,
          hasPermission: true,
        },
        {
          id: 12,
          name: "formation",
          label: this.$t("lang.menu.formation"),
          selected: false,
          hasPermission: true,
        },
        {
          id: 13,
          name: "coldCallTraining",
          label: this.$t("lang.menu.cold_call_training"),
          selected: false,
          hasPermission: true,
        },
        {
          id: 15,
          name: "agentAI",
          label: "Agent-AI",
          selected: false,
          hasPermission: true,
        },
        {
          id: 16,
          name: "analysisWorkshop",
          label: this.$t("lang.menu.analysis_workshop"),
          selected: false,
          hasPermission: true,
        },
      ];
      if (!this.tabs.some((o) => o.selected)) {
        this.$nextTick(() => this.optionSelected(this.optionDefault));
      }
    } else {
      this.tabs = [
        {
          id: 9,
          name: "formation",
          label: this.$t("lang.menu.formation"),
          selected: true,
          hasPermission: true
        },
        {
          id: 1,
          name: "client_info",
          label: this.$t("lang.menu.client_info"),
          selected: false,
          hasPermission: true,
        },
        {
          id: 10,
          name: "coldCallTraining",
          label: this.$t("lang.menu.cold_call_training"),
          selected: false,
          hasPermission: true,
        },
      ];
      this.optionDefault = 9
    }
  },
  methods: {
    ...mapActions("optionsList", {
      getAllOptionsList: "getAllAgencyParams",
    }),
    ...mapActions("header", {
      changeHeaderTab: "changeTab",
    }),
    ...mapActions("campaigns", {
      getCampaignStatsByIdAndRange: "getStatsByIdAndRange",
    }),
    ...mapActions("onboarding", {
      apolloData: "apolloData",
    }),
    newUser() {
      this.$modal.show("sales");
    },
    newemail() {
      // TODO: Implement adding new email account functionality
      // This might open a modal for adding email accounts to users
      console.log("newemail called - implement functionality");
    },
    exportTxt() {
      this.loadingTxt = true;
      console.log("exportTxt");
      this.getInfoForTxt();
    },
    getContractClient() {
      this.loadingContract = true;
      clientsService
        .getContractClient(this.selectedClientId)
        .then(({ blob, filename }) => {
          const downloadName = filename
            ? filename.endsWith(".pdf")
              ? filename
              : `${filename}.pdf`
            : `contract-${this.selectedClientId}.pdf`;
          const url = window.URL.createObjectURL(
            new Blob([blob], { type: "application/octet-stream" }),
          );
          const link = document.createElement("a");
          link.href = url;
          link.download = downloadName;
          link.style.display = "none";
          document.body.appendChild(link);
          link.click();
          link.remove();
          setTimeout(() => window.URL.revokeObjectURL(url), 200);
          this.loadingContract = false;
        })
        .catch((err) => {
          console.log(err);
          this.loadingContract = false;
        });
    },
    getInfoForTxt() {
      console.log("entre")
      clientsService.getAiContext(this.selectedClientId).then((res) => {
        console.log(res);
        this.downloadAiContext(res);
        this.loadingTxt = false;
      }).catch((err) => {
        console.log(err);
        this.loadingTxt = false;
      });
    },
    downloadAiContext(res) {
      const jsonString = JSON.stringify(res, null, 2);
      const filename = `order-data-extract-${this.selectedClientId || "unknown"}-${new Date().toISOString().slice(0, 10)}.txt`;
      const blob = new Blob([jsonString], { type: "text/plain;charset=utf-8" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    getUserOliverExecutives() {
      usersService
        .getUserOliverExecutives()
        .then((res) => {
          if (res.result.length > 0) {
            const userOliverExecutivesWithlabel = res.result.map((el) => ({
              ...el,
              label: el.lastname + ", " + el.name,
            }));
            this.userOliverExecutives.push(...userOliverExecutivesWithlabel);
          }
          this.oliverExecutiveLoaded = true;
        })
        .catch((err) => console.err(err));
    },
    selectOliverExecutive(value) {
      const userOliverExecutiveId = value.id;
      this.savingExceutiveUser = true;
      clientsService
        .assignUserOliverExecutiveToClient(
          userOliverExecutiveId,
          this.selectedClientId
        )
        .then((res) => {
          if (res.result) {
            this.$swal({
              type: "success",
              title: this.$t("lang.label.great"),
              showConfirmButton: false,
              timer: 1500,
            });
          }
          this.savingExceutiveUser = false;
        })
        .catch((err) => console.log(err));
    },
    selectOliverSale(value) {
      const userOliverSaleId = value.id;
      this.model.client.oliver_sale = userOliverSaleId;

      if (userOliverSaleId != this.previewUserOliverSale) {
        this.savingOliverUser = true;
        usersService
          .assignUserOliverSaleToClient(userOliverSaleId, this.selectedClientId)
          .then((res) => {
            if (res.result) {
              this.$swal({
                type: "success",
                title: this.$t("lang.label.great"),
                showConfirmButton: false,
                timer: 1500,
              });
            }
            this.savingOliverUser = false;
          })
          .catch((err) => console.err(err));
        this.previewUserOliverSale = userOliverSaleId;
      }
    },
    getUserOliverSales() {
      usersService
        .getUserOliverSales(true, 0, true)
        .then((res) => {
          if (res.result.length > 0) {
            const userOliverSalesWithlabel = res.result.map((el) => ({
              ...el,
              label: el.lastname + ", " + el.name,
            }));
            this.userOliverSales.push(...userOliverSalesWithlabel);
            this.oliverSalesLoaded = true;
          }
        })
        .catch((err) => console.err(err));
    },

    getColor() {
      switch (this.model.client.client_status_id) {
        case "1":
          return "success";
          break;
        case "2":
          return "secondary";
          break;
        case "3":
          return "primary";
          break;
        case "4":
          return "success";
          break;
        case "5":
          return "warning";
          break;
        case "6":
          return "success";
          break;
        default:
          return "secondary";
      }
    },
    addMemberSales(member) {
      usersService.addSalesRep(member).then((resp) => {
        if (resp) {
          if (typeof resp === "string" && resp.includes("notunique")) {
            this.$modal.hide("sales");
            this.$swal({
              type: "error",
              title: "Error",
              text: "Email Exists",
              showConfirmButton: false,
              timer: 1500,
            });
          } else {
            this.$swal({
              type: "success",
              title: this.$t("lang.label.great"),
              text: this.$t("lang.label.datasavedsuccessfully"),
              showConfirmButton: false,
              timer: 1500,
            });
            this.$modal.hide("sales");
            this.refresh();
          }
        }
      }).catch((error) => {
        const message = typeof error === "string" ? error : "";
        this.$modal.hide("sales");
        this.$swal({
          type: "error",
          title: "Error",
          text: message.includes("notunique")
            ? this.$t("lang.label.emailalreadyexists")
            : this.$t("lang.label.error"),
          showConfirmButton: true,
        });
      });
    },
    getProporsalLink() {
      // Obtener la ubicación actual del navegador
      const location = window.location;

      const baseUrl = `${location.protocol}//${location.host}`;

      return `${baseUrl}/client-service-proposal/${this.model.client.hash}`;
    },
    copyCalendarLink(calendar_link) {
      if (this.copyToClipboard(calendar_link)) {
        this.$swal({
          type: "success",
          title: this.$t("lang.label.great"),
          text: this.$t("lang.general.copiedtoclipboard"),
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },
    copyToClipboard(text) {
      if (window.clipboardData && window.clipboardData.setData) {
        // Internet Explorer-specific code path to prevent textarea being shown while dialog is visible.
        return window.clipboardData.setData("Text", text);
      } else if (
        document.queryCommandSupported &&
        document.queryCommandSupported("copy")
      ) {
        var textarea = document.createElement("textarea");
        textarea.textContent = text;
        textarea.style.position = "fixed"; // Prevent scrolling to bottom of page in Microsoft Edge.
        document.body.appendChild(textarea);
        textarea.select();
        try {
          return document.execCommand("copy"); // Security exception may be thrown by some browsers.
        } catch (ex) {
          console.warn("Copy to clipboard failed.", ex);
          return prompt("Copy to clipboard: Ctrl+C, Enter", text);
        } finally {
          document.body.removeChild(textarea);
        }
      }
    },
    validateDecimalTwoPlaces(value) {
      if (value === undefined || value === null || value === "") {
        return [this.$t("lang.label.isrequired")];
      }

      const regex = /^\d+(\.\d{1,2})?$/;

      if (!regex.test(value)) {
        return [this.$t("lang.validation.number_decimal_negative")];
      }

      if (value < 0) {
        return [this.$t("lang.validation.number_more_than", { max: 0 })];
      }

      return true; // Si es válido, devuelve `true`
    },
    opencalendar(params) {
      myCalendarService.getAvailabilityByDayAll(
        12,
        10,
        3023,
        btoa(params.id),
        160
      );
    },
    clientSignedOn() {
      if (this.model.client && this.model.client.signed_on) {
        return moment(String(this.model.client.signed_on.substr(0, 10))).format(
          "DD/MM/YYYY"
        );
      } else {
        return "-";
      }
    },
    formatLastStatusDate() {
      if (this.model.client && this.model.client.last_status_date) {
        return moment(String(this.model.client.last_status_date).substr(0, 10)).format("DD/MM/YYYY");
      }
      return "-";
    },
    getImageBilling() {
      return require("@/assets/images/emptyperson.png");
    },
    optionSelected(option) {
      this.tabs.forEach((e) => (e.selected = false));
      this.tabs.find((el) => el.id === option).selected = true;

      if (option === 3) {
        this.openTarget = true;
      } else {
        this.openTarget = false;
      }

      if (option === 4) {
        this.activityopen = true;
      } else {
        this.activityopen = false;
      }

      if (option === 6) {
        this.billingDashboardactive = true;
      } else {
        this.billingDashboardactive = false;
      }

      if (option === 7) {
        this.billing = true;
      } else {
        this.billing = false;
      }

      if (option === 8) {
        this.dashboardactive = true;
      } else {
        this.dashboardactive = false;
      }
    },
    setAsFake() {
      this.loading = true;
      clientsService
        .setParameters({
          id: this.selectedClientId,
          hide: 1,
        })
        .then((result) => {
          this.model.client.hide = 1;
          this.loading = false;
          return;
        });
    },
    refresh() {
      this.activityKey++;
    },
    openForm() {
      this.formOpen = true;
      this.currentSalesRep = {};
    },
    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },
    hasPermissionsAdminClients() {
      return this.hasPermissions("adminClients");
    },
    getApollo(data) {
      this.targetdata = false;
      targetsService
        .getApollo(data)
        .then((response) => {
          const searchError = parseContactSearchError(response);
          const apollo = {
            people: [],
            total_result: 0,
            search_error: searchError,
          };
          if (!searchError && response != "Invalid access credentials.") {
            apollo.people = response.people || [];
            apollo.total_result =
              response.pagination && response.pagination.total_entries != null
                ? response.pagination.total_entries
                : 0;
          } else if (response === "Invalid access credentials.") {
            apollo.search_error = {
              key: "contact_search_error_invalid_credentials",
            };
          }
          this.apolloData(apollo);
          this.targetdata = apollo;
          this.openModal("target");
        })
        .catch(() => {
          const apollo = {
            people: [],
            total_result: 0,
            search_error: { key: "contact_search_error_generic" },
          };
          this.apolloData(apollo);
          this.targetdata = apollo;
          this.openModal("target");
        });
    },
    editItemTarget(model, index, current) {
      this.openModal("targetedit");
      this.editItem(model, index, current);
    },
    editAnItem(index) {
      this.formOpen = true;
      this.editItem("model.salesRep", index, "currentSalesRep");
    },
    removeAnItem(index) {
      this.removeItem("model.salesRep", index);
    },
    openTeam(params) {
      this.sales_selected = params;
      this.$modal.show("team");
    },
    openModal(name) {
      this.$modal.show(name);
    },
    closeModal(name) {
      this.$modal.hide(name);
    },
    updateCant(cant) {
      this.keywordscant = cant;
    },
    copyItem(index) {
      var newtarget = JSON.parse(JSON.stringify(this.model.targets[index]));
      newtarget.id = null;
      this.model.targets[this.model.targets.length] = newtarget;
      this.targetsKey++;
      // this.$forceUpdate();
    },
    openSalesRep(open) {
      this.formOpen = open;
    },
    addTarget() {
      this.$refs.targetForm.validate();
      this.$refs.employeesForm.validate();
      // custom validation
      if (
        (this.$refs.targetForm.errors !== undefined &&
          this.$refs.targetForm.errors.length > 0) ||
        (this.$refs.employeesForm.errors !== undefined &&
          this.$refs.employeesForm.errors.length > 0) ||
        ((this.currentTarget.data.employees === undefined ||
          this.currentTarget.data.employees.keywords === undefined ||
          this.currentTarget.data.employees.keywords.greater === undefined) &&
          (this.currentTarget.data.employees === undefined ||
            this.currentTarget.data.employees.keywords === undefined ||
            this.currentTarget.data.employees.keywords.less === undefined) &&
          (this.currentTarget.data.categories_industry === undefined ||
            this.currentTarget.data.categories_industry.length == 0) &&
          (this.currentTarget.data.region === undefined ||
            this.currentTarget.data.region.length == 0) &&
          (this.currentTarget.data.categories_level === undefined ||
            this.currentTarget.data.categories_level.length == 0) &&
          (this.currentTarget.data.categories_function === undefined ||
            this.currentTarget.data.categories_function.length == 0) &&
          (this.currentTarget.data.countries === undefined ||
            this.currentTarget.data.countries.length == 0))
      ) {
        return;
      }
      this.closeModal("targetedit");
      this.addItem(
        "model.targets",
        "currentTarget",
        "name",
        "targetForm,employeesForm"
      );
      this.targetsKey++;
    },
    saveFormation() {
      this.setFormation();
      this.editFormation = false;
    },
    updateFormation() {
      this.editFormation = true;
    },
    setFormation() {
      clientsService.updateFormation(this.model.client.id, this.model.client.formation).then((response) => {
        this.$swal({
          type: "success",
          title: this.$t("lang.label.datasavedsuccessfully"),
          showConfirmButton: false,
          timer: 6000,
        });
      })
    },
    /** HTTPS y host notion.so / www.notion.so / *.notion.site */
    isNotionPlaybookUrl(urlString) {
      if (urlString == null || typeof urlString !== "string") return false;
      const s = urlString.trim();
      if (!s) return false;
      let url;
      try {
        url = new URL(s);
      } catch {
        return false;
      }
      if (url.protocol !== "https:") return false;
      const host = url.hostname.toLowerCase();
      return host === "notion.so" || host === "www.notion.so" || host.endsWith(".notion.site");
    },
    agencyFormValidate() {
      const client = this.model && this.model.client;
      if (this.churnCategoryIsRequired && !this.hasChurnCategory) {
        const offerTab = this.tabs.find((tab) => tab.name === "offer_view");
        if (offerTab && !offerTab.selected) {
          this.optionSelected(offerTab.id);
        }

        this.$nextTick(() => {
          const churnCategorySelect = this.$el.querySelector(
            ".churn-category-field select",
          );
          if (churnCategorySelect) {
            churnCategorySelect.focus();
          }
        });

        this.$swal({
          type: "warning",
          title: this.$t("lang.label.missingdata"),
          text: "La catégorie de churn est obligatoire.",
          showCancelButton: false,
          confirmButtonText: this.$t("lang.button.ok"),
        });
        return false;
      }

      const subscriptionIsActive =
        client && Number(client.subscriptionActive) === 1;
      const hasKickoffDate =
        client &&
        client.kickoff_date != null &&
        String(client.kickoff_date).trim() !== "";

      // Account Managers are never blocked by a missing kickoff date: the
      // pause/resume select is only enabled while the subscription is active,
      // so this guard would make pausing unreachable for clients without one.
      if (this.isAccountManager || !subscriptionIsActive || hasKickoffDate) {
        return true;
      }

      const offerTab = this.tabs.find((tab) => tab.name === "offer_view");
      if (offerTab && !offerTab.selected) {
        this.optionSelected(offerTab.id);
      }

      this.$nextTick(() => {
        const offerForm = this.$refs.offerForm;
        if (offerForm) {
          offerForm.validate();
        }

        const kickoffInput = this.$el.querySelector(
          ".kickoff-date-field input",
        );
        if (kickoffInput) {
          kickoffInput.focus();
        }
      });

      return false;
    },
    setAgency() {
      if (!this.agencyFormValidate()) {
        this.setAgencyKey++;
        return;
      }

      const dedicatedBookers = this.model.client.dedicated_bookers;
      const dedicatedBookersNumber =
        dedicatedBookers === null ||
        dedicatedBookers === undefined ||
        dedicatedBookers === ""
          ? 0
          : Number(dedicatedBookers);

      if (
        Number.isNaN(dedicatedBookersNumber) ||
        dedicatedBookersNumber < 0 ||
        dedicatedBookersNumber > 40
      ) {
        this.$swal({
          type: "warning",
          title: this.$t("lang.label.missingdata"),
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33a2c",
          confirmButtonText: this.$t("lang.button.ok"),
        });
        this.setAgencyKey++;
        return;
      }

      // Cancelling asks its own confirmation BEFORE the save one: sweetalert2
      // replaces the popup that is already open, so firing both at once hid the
      // cancellation warning entirely.
      const wasActive = Number(this.originalSubscriptionId) === 1;
      const willBeActive = Number(this.model.client.subscriptionActive) === 1;

      if (wasActive && !willBeActive) {
        this.cancelledSubscription().then((confirmed) => {
          if (!confirmed) {
            this.setAgencyKey++;
            return;
          }
          this.confirmAndSaveAgency();
        });
        return;
      }

      this.confirmAndSaveAgency();
    },
    confirmAndSaveAgency() {
      this.$swal({
        type: "warning",
        title: this.$t("lang.label.areyousure"),
        text: this.$t("lang.label.confirmationsaveclient"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.button.yes"),
        cancelButtonText: this.$t("lang.button.cancel"),
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          if (this.model.client.ai_meeting_analisis == null || this.model.client.ai_meeting_analisis === "") {
            this.model.client.ai_meeting_analisis = "0";
          }

          if(this.model.client.playbook_url == "" || this.model.client.playbook_url == undefined){
            this.model.client.playbook_url = null;
          }

          const data = {
            user: this.model.user,
            client: {
              ...this.model.client,
              subscriptionFreeOriginal: this.originalSubscriptionFree,
            },
          };

          clientsService
            .setAgency(data)
            .then((response) => {
              if (this.selectedClientId === undefined) {
                this.selectedClientId = response;
              }
              this.getAgency();
              this.$swal({
                type: "success",
                title: this.$t("lang.label.datasavedsuccessfully"),
                showConfirmButton: false,
                timer: 6000,
              });
              this.loading = false;
            })
            .catch((err) => {
              this.$swal({
                type: "error",
                title: this.$t("lang.label.error"),
                showCancelButton: false,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33a2c",
                confirmButtonText: this.$t("lang.button.ok"),
              });
              this.setAgencyKey++;
              this.loading = false;
            });
        } else {
          this.setAgencyKey++;
          return;
        }
      });
    },
    getTaskTypeTitle(title) {
      if (title.indexOf("lang.") !== -1) {
        let message = JSON.parse(title);
        return this.$t(message.lang_message);
      }
      return title;
    },
    cancelledSubscription() {
      return this.$swal({
        type: "warning",
        title: this.$t("lang.label.areyousure"),
        text: this.$t("lang.label.monthlysubscription_cancel"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.button.yes"),
        cancelButtonText: this.$t("lang.button.cancel"),
      }).then((result) => {
        if (result.value) {
          this.model.client.subscriptionActive = "0";
          return true;
        }
        this.model.client.subscriptionActive = this.originalSubscriptionId;
        this.model.client.subscriptionFree = this.originalSubscriptionFree;
        return false;
      });
    },
    getStats() {
      this.loadingData = true
      //this.loadingStats = true
      clientsService.getStats(this.selectedClientId)
        .then((response) => {
          this.model.client.stats = response
          //this.loadingStats = false

          clientsService.getColdMeetingRate([this.selectedClientId]).then((response) => {
            const cold_meeting_rate =
              response.result &&
              response.result.find((el) => el.type == "cold_meeting_rate");
            if (cold_meeting_rate && this.model.client.stats) {
              this.model.client.stats.cold_meeting_rate = cold_meeting_rate.total;
            }
          });

        })
        .catch((err) => {
          console.err(err);
        })
        .finally(() => {
          this.loadingData = false;
        })
    },
    getClientAffiliation() {
      this.loadingAffiliation = true;
      clientsService.getClientsForAffiliation().then((response) => {
        console.log(response);
        this.clientsAffiliation = response;
      })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loadingAffiliation = false
        })

    },
    getAgency() {
      //this.model = this.model_empty;
      //this.model_init = this.model;
      this.loading = true;

      if (this.selectedClientId !== undefined) {
        if (this.selectedClientId != undefined) {
          clientsService.getAgency(this.selectedClientId).then((response) => {
            this.model = response;
            if (!Object.prototype.hasOwnProperty.call(this.model.client, "churn_category")) {
              this.$set(this.model.client, "churn_category", "");
            } else if (this.model.client.churn_category == null) {
              this.model.client.churn_category = "";
            }
            this.originalChurnContext = this.isChurnContext;
            this.model.client.ai_meeting_analisis = this.model.client.ai_meeting_analisis != null
              ? String(this.model.client.ai_meeting_analisis)
              : "0";
            // API may return this as a string ("1"); keep it numeric so the
            // number input and its validator behave.
            if (
              this.model.client.dedicated_bookers !== null &&
              this.model.client.dedicated_bookers !== undefined &&
              this.model.client.dedicated_bookers !== ""
            ) {
              const bookers = Number(this.model.client.dedicated_bookers);
              if (!Number.isNaN(bookers)) {
                this.model.client.dedicated_bookers = bookers;
              }
            }
            // kickoff_date is TIMESTAMP in DB; date input + API expect Y-m-d
            if (this.model.client.kickoff_date) {
              const kd = String(this.model.client.kickoff_date);
              this.model.client.kickoff_date = kd.length >= 10 ? kd.substring(0, 10) : kd;
            }
            this.userOliverSale = (this.model.client.oliver_sale) ? [this.model.client.oliver_sale] : ['0'];
            this.UserOliverExecutive = this.model.client.account_executive_user_id;
            this.originalSubscriptionId = this.model.client.subscriptionActive;
            this.originalSubscriptionFree = this.model.client.subscriptionFree;
            document.title = this.model.client.name;

            this.model.client.domain_config.forEach((domain) => {
              this.domain_config_values.push({
                id: domain.id,
                name: domain.domain,
              });
            });
            if (this.model.client.vat_number != null)
              this.model.client.vat_number =
                this.model.client.vat_number.substr(4);
            if (this.model.client.accountManager != null) {
              this.model.client.hasAccountManager =
                this.model.client.accountManager;
            } else {
              this.model.client.hasAccountManager = null;
              this.model.client.accountManager = null;
            }
            if (
              this.model.salesRep !== undefined &&
              this.model.salesRep !== null
            ) {
              this.model.salesRep.forEach((sales) => {
                this.salesRepList.push({
                  id: sales.id,
                  label: sales.first_name + " " + sales.last_name,
                });
              });
            }
            if (
              this.model.client &&
              this.model.client.keywords !== undefined &&
              this.model.client.keywords !== null
            ) {
              if (!Object.hasOwn(this.model.client.keywords, "anyof")) {
                if (this.model.client.keywords !== "") {
                  let words = this.model.client.keywords.split(",");
                  let wordArray = [];
                  words.forEach((element) => {
                    wordArray.push({ word: element });
                  });

                  this.keywords.anyof = wordArray;
                }
              } else {
                this.keywords = this.model.client.keywords;
              }
            }

            if (this.model.client.country) {
              this.hierarchyoptionsCountry.forEach((country) => {
                if (country.label == this.model.client.country) {
                  this.country.push(country.label);
                }
              });
            }

            if (
              this.model.targets !== undefined &&
              this.model.targets !== null
            ) {
              this.model.targets.forEach((target) => {
                // convert empty array into object
                if (Array.isArray(target.data.employees)) {
                  target.data.employees = {};
                }
                if (
                  target.data.categories_jobs === undefined ||
                  Array.isArray(target.data.categories_jobs)
                ) {
                  target.data.categories_jobs = {};
                }
              });
            }
            if (
              this.model.client.pitch !== undefined &&
              this.model.client.pitch !== null
            ) {
              this.editorPitch = this.model.client.pitch;
            }
            if (
              this.model.client.extra_info !== undefined &&
              this.model.client.extra_info !== null
            ) {
              this.editorExtraInfo = this.model.client.extra_info;
            }
            if (
              this.model.client &&
              this.model.client.signed_on !== undefined &&
              this.model.client.signed_on !== null
            ) {
              this.model.client.signed_on = this.model.client.signed_on
                .replace(" ", "T")
                .substring(0, 16);
            }
            this.model_init = JSON.parse(JSON.stringify(this.model));
            this.loading = false;
          });
        } else {
          this.loading = false;
        }
      } else {
        this.loading = false;
      }
    },
    goBack() {
      if (this.hasPermissions("adminClients")) {
        this.changeHeaderTab({ tab: "ALL" });
      } else {
        this.$router.push("/contract");
      }
    },
    changeKeywords(event) {
      this.model.client.keywords = event;
    },
    covertArray(industry) {
      if (industry != "" && industry != null) {
        return industry.split(",");
      } else {
        return [];
      }
    },
    getFormation() {
      this.formationLoading = true;
      openaiService.getFormation(this.model.client.website).then((res) => {
        this.model.client.formation = res.data;
        this.formationLoading = false;
      });
    },
    removeClass() {
      // let element = document.getElementById('orders')
      // let myElement = element.getElementsByClassName('main')
      // myElement[0].classList.remove('main')
    },

    preprocessMarkdown(text) {
      if (!text) return '';

      return text
        .replace(/(---)/g, '\n$1\n')              // separadores
        .replace(/(#{2,4} .*?)/g, '\n$1\n')       // títulos ##, ###, ####
        .replace(/(- .*)/g, '\n$1')               // listas
        .replace(/\*\*\*/g, '**')                 // triple ** a doble **
        .replace(/\\n/g, '\n');                   // si viene con \\n en vez de \n reales
    },
    parseMarkdown(text) {
      if (!text) return '';

      // Paso 1: normalizar saltos y espacios
      let lines = text.trim().split('\n');
      let html = '';
      let inList = false;

      for (let i = 0; i < lines.length; i++) {
        let line = lines[i].trim();

        // Separador "---"
        if (/^---+$/.test(line)) {
          if (inList) {
            html += '</ul>';
            inList = false;
          }
          html += '<hr />';
          continue;
        }

        // Títulos
        if (/^#### /.test(line)) {
          if (inList) {
            html += '</ul>';
            inList = false;
          }
          html += `<h4>${line.replace(/^#### /, '')}</h4>`;
          continue;
        }
        if (/^### /.test(line)) {
          if (inList) {
            html += '</ul>';
            inList = false;
          }
          html += `<h3>${line.replace(/^### /, '')}</h3>`;
          continue;
        }
        if (/^## /.test(line)) {
          if (inList) {
            html += '</ul>';
            inList = false;
          }
          html += `<h2>${line.replace(/^## /, '')}</h2>`;
          continue;
        }
        if (/^# /.test(line)) {
          if (inList) {
            html += '</ul>';
            inList = false;
          }
          html += `<h1>${line.replace(/^# /, '')}</h1>`;
          continue;
        }

        // Lista
        if (/^- /.test(line)) {
          if (!inList) {
            html += '<ul>';
            inList = true;
          }
          html += `<li>${line.replace(/^- /, '')}</li>`;
          continue;
        }

        // Línea vacía
        if (line === '') {
          if (inList) {
            html += '</ul>';
            inList = false;
          }
          html += '<br />';
          continue;
        }

        // Negritas y cursivas
        line = line.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
        line = line.replace(/\*(.*?)\*/g, '<em>$1</em>');

        // Línea normal
        if (inList) {
          html += '</ul>';
          inList = false;
        }
        html += `<p>${line}</p>`;
      }

      if (inList) {
        html += '</ul>';
      }

      return html;
    },
  },
  watch: {
    editorPitch: function () {
      this.model.client.pitch = this.$sanitize(this.editorPitch);
    },
    editorExtraInfo: function () {
      this.model.client.extra_info = this.$sanitize(this.editorExtraInfo);
    },
    "model.client.subscriptionActive"(newVal) {
      if (newVal == "0") {
        this.model.client.subscriptionFree = 0;
      } else if (newVal == this.originalSubscriptionId) {
        // Sub Off -> On again: restore the loaded pause value, or a paused
        // subscription would start billing on save.
        this.model.client.subscriptionFree = this.originalSubscriptionFree;
      }
    },
    "model.client.contacts_active"(newVal) {
      if (newVal == "0") {
        this.model.client.contacts_price_per_month = 0;
      }
    },
    "model.client.bank_transfer_enabled"(newVal) {
      if (newVal == "0") {
        this.model.client.bank_transfer_contractual_days = 0;
      }
    },
  },
};
</script>
<style scoped>
/* Contorno que enmarca header + menú izquierdo + contenido */
.agency-form-frame {
  border-top: 1px solid #dee2e6;
  border-left: 0.5px solid #dee2e6;
  overflow: hidden;
  background: #fff;
}

.agency-header-calendar-icon {
  width: 2.25rem;
  height: 2.25rem;
  min-width: 2.25rem;
}

.agency-header-calendar-wrap {
  min-width: 0;
}

.agency-header-calendar-wrap .min-width-0 {
  min-width: 0;
}

.badge-agency-header.badge-success {
  background-color: #d4edda;
  color: #155724;
}

/* Responsivo 60%-110% zoom: flex-wrap y min-width para que no se deforme */
.agency-header-row {
  row-gap: 0.5rem;
}

.agency-header-row>[class*="col-"] {
  min-width: 0;
}

.agency-header-metrics {
  min-width: 0;
  gap: 0.25rem 0.5rem;
}

.agency-summary-metric .agency-header-metric-icon {
  width: 20px !important;
  height: 20px !important;
  min-width: 20px !important;
  display: block;
  padding: 0;
  margin: 0;
}

.agency-header-metrics .agency-header-metric-val {
  font-size: 0.8rem;
  margin-left: 0.2rem;
  margin-right: 0.4rem;
  white-space: nowrap;
}

.agency-header-metrics .agency-header-metric-gap {
  margin: 0 0.2rem;
  padding: 0;
}

.agency-header-metrics .agency-header-metric-refresh {
  margin-left: 0.25rem;
  font-size: 0.9rem;
}

/* Summary stats: Activity + Conversion rates layout */
.agency-summary-stats-wrapper {
  min-width: 0;
}

.agency-summary-refresh {
  font-size: 0.9rem;
  flex-shrink: 0;
}

.agency-summary-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.agency-summary-metrics-row {
  gap: 1.5rem 2.5rem;
}

.agency-summary-metric {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
  padding-right: 0.5rem;
}

.agency-summary-metric-user-icon {
  font-size: 1.125rem;
  margin-bottom: 0.25rem;
}

.agency-summary-metric-gap {
  margin: 0.2rem 0;
}

.agency-summary-metric-val {
  font-size: 1.35rem;
  font-weight: 700;
  color: #212529;
  line-height: 1.2;
}

.agency-summary-metric-label {
  font-size: 0.8rem;
  color: #6c757d;
  margin-top: 0.25rem;
  line-height: 1.2;
}

.agency-header-title {
  word-break: break-word;
}

.markdown-content {
  line-height: 1.6;
}

.markdown-content ul {
  margin-left: 1em;
  list-style: disc;
}

.overlay-image {
  position: relative;
  margin-top: -90px;
  /* Ajusta esta cantidad para controlar la posición vertical de la imagen */
}

.overlay-image img {
  width: 200px;
  /* Ajusta el tamaño de la imagen según tus necesidades */
  border-radius: 50%;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
}

@media (min-width: 990px) {
  .main {
    margin-left: 150px !important;
  }
}

.display-inline label,
.display-inline .field-wrap {
  width: 50%;
  float: left;
}

.display-inline label {
  text-align: right;
  padding-right: 10px;
  min-height: 50px;
}

.display-inline .errors,
.display-inline .hint {
  width: 50%;
  float: right;
  padding-left: 2px;
}

/* .col-12{ height:80px; } */
img {
  margin-top: 1%;
  margin-left: 10px;
}
</style>
